import { map } from "rxjs/operators";
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  DebugElement,
} from "@angular/core";
import { DataService } from "../data.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CountryService } from "../country.service";
import { DecimalPipe } from "@angular/common";
import { parse, format, AsYouType } from "libphonenumber-js";
import { IMyDpOptions, IMyDateModel, IMyDate } from "mydatepicker";
// import {clearTimeout, setTimeout} from 'timers';
import { EventsService } from "angular4-events";
import { Constants } from "../constants";

declare var $: any;
declare var google: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: "app-create-order",
  templateUrl: "./create-order.component.html",
  styleUrls: ["./create-order.component.css"],
})
export class CreateOrderComponent implements OnInit {
  @ViewChild("mapCanvas2") mapElement2: ElementRef;

  priceIconForDouble = Constants.iconForDoublePrice;
  businessAlreadyCollected = [
    { tag: "By Cash", value: 4 },
    { tag: "By Card", value: 5 },
  ];
  busiColPay: any;
  busiColPayVal = "Business Already Collected Pay";
  clearTimeout: any;
  clearTimeoutCustomer: any;
  searchString: any;
  numChk = false;
  countryCode: any;
  searchStringCustomer: any;
  searchStringOutlet: any;
  productData: any;
  customerData: any;
  outletData: any;
  outletNationWide: any;
  logisticsOrder = false;
  customerDataLength: any;
  productDataLength: any;
  outletDataLength: any;
  restErrorCode: any;
  productDisplayDataArray = new Array();
  customerDisplayDataArray = new Array();
  outletDisplayDataArray = new Array();
  calculationArray = new Array();
  nao = new Nanobar();
  quantityTotal: any;
  CustomerSearchBox = true;
  editAddress = false;
  outletSearchBox = false;
  totalPrice: any;
  subTotal: any;
  charges: any;
  myTemp: any;
  discount: any;
  fieldDisable = true;
  chargeFieldDisable = true;
  notes: any;
  finalProduct = new Array();
  outletAddress: any;
  deliveryAddress: any;
  finalQuantity: any;
  // tax_charges = 10;
  tax_charges: any;
  tax_chargesToDisplay: any;
  orderSuccess: any;
  orderMessage: any;
  orderStatus: any;
  totalPriceDiscount: any;
  place: any;
  address: any;
  placeForEditAddress: any;
  prefilledCustomerData: any;
  // customer add variables
  first_name: any;
  last_name: any;
  number: any;
  email: any;
  is_tax_exempt = false;
  accept_marketing = false;
  address_line1: any;
  address_line2: any;
  latitude: any;
  longitude: any;
  street: any;
  street3: any;
  city: any;
  state: any;
  zip: any;
  area: any;
  apart: any;
  note: any;
  dob: any;
  houseNo: any;
  editHouseNo: any;
  preventCall = false;
  private today = new Date();
  selDate: any;
  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "mm/dd/yyyy",
    showTodayBtn: true,
    todayBtnTxt: "Today",
    showClearDateBtn: false,
    indicateInvalidDate: true,
    editableDateField: false,
    openSelectorOnInputClick: true,
    disableSince: { year: this.today.getFullYear() - 20, month: 1, day: 1 },
    // minYear: this.today.getFullYear() - 20,
    // disableSince: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1}
    // disableUntil: {year: 0, month: 0, day: 0}
  };
  success: any;
  addingCustomer = false;
  numberChkError: any;
  btnDisableOrder = false;
  error_count: any;
  emailChk: any;
  findCustomerData: any;
  customerMatch = false;
  mycharges: any;
  latitude2: any;
  longitude2: any;
  createorderResponseUpdate: any;
  createorderResponse: any;
  updateError: any;
  btnDisable = false;
  maxYear: any;
  placeSuggestionsData: any;
  placeDetailData: any;
  placeDataFound = false;
  addressLoad = false;
  placeSuggestionsData2: any;
  placeDetailData2: any;
  placeDataFound2 = false;
  addressLoad2 = false;
  platformFeeData: any;
  map2: any;
  customerLat: any;
  customerLong: any;
  outletLat: any;
  outletLong: any;
  mapEle2: any;
  markerDrivers = new Array();
  markerCustomer = new Array();
  dispensaryData: any;
  isNation: any;
  isLocal: any;
  delivery_man_type: any;
  customerPrimeryCardNo = "";
  paymentThroughCard: any;
  paymentThroughCash: any;
  paymentMethodOptionValue = -1;
  paymentCardData: any;
  primaryCardNo = "";
  removeCardData: any;
  primaryDataSuccess: any;
  cardNum: any;
  cardName: any;
  expiryDate: any;
  card_cvv: any;
  cardType: any;
  expiryDateError = 0;
  cardSuccess: any;
  cardMessage: any;
  businessProfileData: any;
  logisticsChecked = false;
  messages: any = { validDate: "valid\ndate", monthYear: "mm/yyyy" };
  placeholders: any = {
    number: "•••• •••• •••• ••••",
    name: "Full Name",
    expiry: "••/••",
    cvc: "•••",
  };
  masks: any;
  deleteCardNoId: any;
  showPaymentView = false;
  disabledClick: any;
  selectAddress = false;
  selectAddressCustomer = false;
  customerAddressList = [];
  selectedCustomerId: any;
  selectedCustomerObj: any;
  placeLabel = "";
  CustomeplaceLabel = "";
  placeLabelDefault = "";
  placeLabelError = "";
  idval: any;
  todayData1 = new Date();
  todayData = this.todayData1.getDay();
  timeSlotDetail: any;
  outletIdToSendInCheckout: any;
  over_night_charges: any;
  days_charges: any;
  timeSlotDetail_delivery: any;
  businessTypeFromSlotRequest: any;
  timeSlotDetail_delivery_show = new Array();
  timeSlotDetail_delivery_charges = 0;
  third_party_string = "";
  dayOfGivenTime = "";
  dayIndex: any;
  time: any;
  overnight = "";
  slotSuccessMessage = "";
  clearTimeoutProduct: any;
  slotSuccess: any;
  freeCount = 0;
  infoData: any;
  breakdownCharges = 0;
  breakdownChargesTotal = 0;
  breakdownChargesDis = 0;
  timeSlotDetailOrignal: any;
  showBreakdownIcon = false;
  editAddressId: any;
  count = 0;
  platform_fee_waive_off: any;
  noOptionsPrice: number;
  addItValue: number;
  actualPrice: number;
  productModifierDataArray = new Array();
  addonsArr = new Array();
  noOptionsArr = new Array();
  modifiersArr = new Array();
  priceAddon: any;
  variantPrice: any;
  varianId: any;
  changeCheck: any = "temporary";
  variantName: any;
  check: any = false;
  variantNameCheck: any = "temporary";
  variantOptionName: any;
  timeSlotDetail_delivery_charges_actual = 0;
  gender: any = -1;
  isDineIn: any;
  isPickUp: any;
  multipleOptions: boolean = false;
  nationLocal: boolean;
  nationPick: boolean;
  nationDine: boolean;
  dinePick: boolean;
  localDine: boolean;
  localPick: boolean;
  nationLocalDine: boolean;
  localDinePick: boolean;
  nationlocalPick: boolean;
  nationDinePick: boolean;
  business_type: any;
  isPickUpVal: boolean;
  isDineInVal: boolean;
  isLocalVal: boolean;
  isNationVal: boolean;
  pickUpCheck: boolean = false;
  closeBtnClick: boolean = false;
  pickUpFlag: boolean;
  cardNumber: any;
  cash_tax: number = 0;
  card_tax: number = 0;
  cash_check: boolean;
  cardCheck: boolean;
  card_check: boolean;
  taxPriceDiscount: any;
  totalQuantity: any;
  lat = 51.678418;
  lng = 7.809007;
  math = Math;
  final_answer: any;
  paymentThroughBankTransfer: string;
  paymentThroughMpos: string;
  mos_check: boolean;
  bank_check: boolean;
  already_paid: boolean;
  marketPlaceOrder = false;
  orderType = false;

  constructor(
    private dataService: DataService,
    private cs: CountryService,
    private router: Router,
    private chRef: ChangeDetectorRef,
    private events: EventsService
  ) {
    this.subTotal = 0;
    // this.tax_chargesToDisplay = 0;
    this.discount = 0;
    // this.charges = 0;
    // if (window.localStorage.getItem('isauthenticated') !== 'true') {
    //   window.location.href = '/';
    // }
    if (window.localStorage.getItem("isauthenticated") !== "true") {
      this.router.navigate(["/"]);
    }
    if (
      window.localStorage.getItem("userRole") === "3" &&
      window.localStorage.getItem("isauthenticated") === "true"
    ) {
      this.router.navigate(["orders"]);
    }
    setTimeout(() => {
      this.maxYear = new Date().getFullYear();
      this.maxYear = parseInt(this.maxYear, 10) - 21;
      this.selDate = "01/01/" + this.maxYear;
      this.dob = this.selDate;
    }, 1500);
    this.dataService.routeView = "orders";
    this.dataService.routeViewOutlet = "orders";
    $(".AddNewAddressCustomerMain").css("display", "none");
    $(".createOrderPageMain").css("display", "bloack");

    this.idval = this.events
      .subscribe("AddAddressCustomerDone")
      .subscribe((_data) => {
        console.log("in create order");
        var number = this.selectedCustomerObj.id;
        // var number =  this.selectedCustomerObj.country_code + this.selectedCustomerObj.phone_number;
        // number = number.replace('(', '');
        // number = number.replace(')', '');
        // number = number.replace('-', '');
        // number = number.replace(/\s/g, '');
        this.prefindCustomerForDisplayData(number);
      });
  }

  dispensaryDetails: any;
  businessName = "Business - All";
  dispensaryId: any;

  getDispensaryListing() {
    // console.log('e');
    this.dataService
      .getdispensaryListing(localStorage.getItem("token"))
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.dispensaryDetails = data;
          this.businessName = "Bussiness";
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
          toastr.error("Some thing went wrong");
        }
      );
  }

  dispensary_id: any;

  filterBusinessId(id) {
    this.dispensary_id = id;
    // this.businessName = name;
    console.log("despansaryid", id);
    //this.getDispensaryListing();
    this.searchOutletOnOrder();
    this.get_dispensary_information();
    this.getBusinessProfile();
    this.getPlatformFeeFunction();
  }

  onChooseLocation(event) {
    this.lat = event.coords.lat;
    this.lng = event.coords.lng;
    this.lat = this.outletData[0].latitude;
    this.lng = this.outletData[0].longitude;
    console.log(this.lat, this.lng);
  }

  businessCollectedUpdation(id, val) {
    this.busiColPay = id;
    this.busiColPayVal = val;
  }

  get_dispensary_information() {
    this.dataService
      .dispensary_information(
        window.localStorage.getItem("token"),
        this.dispensary_id
      )
      .subscribe(
        (data) => {
          this.dispensaryData = data;
          this.isNation = this.dispensaryData.is_nation_wide;
          this.isLocal = this.dispensaryData.is_local;
          this.isDineIn = this.dispensaryData.is_dine_in_available;
          this.isPickUp = this.dispensaryData.is_pickup_order_available;
          this.clearTimeout = setTimeout(() => {
            if (
              this.isNation === true &&
              this.isLocal === false &&
              this.isDineIn === false &&
              this.isPickUp === false
            ) {
              this.isNationVal = true;
              $(".isNation").prop("checked", true);
              this.delivery_man_type = 3;
            }
            if (
              this.isNation === false &&
              this.isLocal === true &&
              this.isDineIn === false &&
              this.isPickUp === false
            ) {
              this.isLocalVal = true;
              $(".isLocal").prop("checked", true);
              this.delivery_man_type = 1;
            }
            if (
              this.isNation === false &&
              this.isLocal === false &&
              this.isDineIn === true &&
              this.isPickUp === false
            ) {
              this.isDineInVal = true;
              // $('.isDineIn').prop('checked', true);
              this.delivery_man_type = 4;
            }
            if (
              this.isNation === false &&
              this.isLocal === false &&
              this.isDineIn === false &&
              this.isPickUp === true
            ) {
              this.isPickUpVal = true;
              $(".isPickUp").prop("checked", true);
              this.delivery_man_type = 5;
            }
            if (
              this.isNation === true &&
              this.isLocal === true &&
              this.isDineIn === false &&
              this.isPickUp === false
            ) {
              this.nationLocal = true;
            }
            if (
              this.isNation === true &&
              this.isPickUp === true &&
              this.isLocal === false &&
              this.isDineIn === false
            ) {
              this.nationPick = true;
            }
            if (
              this.isNation === true &&
              this.isDineIn === true &&
              this.isLocal === false &&
              this.isPickUp === false
            ) {
              this.nationDine = true;
            }
            if (
              this.isDineIn === true &&
              this.isPickUp === true &&
              this.isNation === false &&
              this.isLocal === false
            ) {
              this.dinePick = true;
            }
            if (
              this.isLocal === true &&
              this.isDineIn === true &&
              this.isPickUp === false &&
              this.isNation === false
            ) {
              this.localDine = true;
            }
            if (
              this.isLocal === true &&
              this.isPickUp === true &&
              this.isNation === false &&
              this.isDineIn === false
            ) {
              this.localPick = true;
            }
            if (
              this.isNation === true &&
              this.isLocal === true &&
              this.isDineIn === true &&
              this.isPickUp === false
            ) {
              this.nationLocalDine = true;
            }
            if (
              this.isNation === false &&
              this.isLocal === true &&
              this.isDineIn === true &&
              this.isPickUp === true
            ) {
              this.localDinePick = true;
            }
            if (
              this.isNation === true &&
              this.isLocal === true &&
              this.isDineIn === false &&
              this.isPickUp === true
            ) {
              this.nationlocalPick = true;
            }
            if (
              this.isNation === true &&
              this.isLocal === false &&
              this.isDineIn === true &&
              this.isPickUp === true
            ) {
              this.nationDinePick = true;
            }
            if (
              this.isNation === true &&
              this.isLocal === true &&
              this.isDineIn === true &&
              this.isPickUp === true
            ) {
              this.multipleOptions = true;
            }
            // console.log('delivery_man_typedelivery_man_typedelivery_man_typedelivery_man_type', this.delivery_man_type);
          }, 2000);
        },
        (error) => {
          console.log("error", error);
        }
      );
  }

  platformFeeWaivedOffFtn() {
    this.count++;
    if (this.count % 2 != 0) {
      this.platform_fee_waive_off = true;
    } else {
      this.platform_fee_waive_off = false;
    }
  }
  updateLogisticsFunc( val, _event) {
    // if (this.logisticsOrder === false) {
    //   this.logisticsOrder = true;
    // } else if (this.logisticsOrder === true) {
    //   this.logisticsOrder = false;
    // }
    // console.log(this.logisticsOrder);

    if (val === '1'){
      $(".isMarketPlace").prop("checked", false);
      $(".isLogistics").prop("checked", true);
      this.logisticsChecked = true;
       this.logisticsOrder = true
       this.orderType = true
    }
      else if (val === '2'){
      $(".isLogistics").prop("checked", false);
      $(".isMarketPlace").prop("checked", true);
      this.logisticsChecked = true ;
      this.marketPlaceOrder = true ;
      this.orderType= true;
     }

    // else {
    //   this.logisticsChecked = false ;
    //   toastr.error("Please select order type");
    // }

  }

  updateDeliveryFunc(val, event) {
    if (val === "1") {
      $(".isNation").prop("checked", false);
      $(".isDineIn").prop("checked", false);
      $(".isPickUp").prop("checked", false);
      if (event.target.checked == true) {
        $("#delivery_address").css("display", "block");
        this.delivery_man_type = 1;
        this.pickUpCheck = false;
        this.getSlotsDataWithAddress();
      } else {
        // this.pickUpCheck = true;
        this.getSlotsDataWithAddress();
      }
    }
    if (val === "3") {
      $(".isLocal").prop("checked", false);
      $(".isDineIn").prop("checked", false);
      $(".isPickUp").prop("checked", false);
      if (event.target.checked == true) {
        $("#delivery_address").css("display", "block");
        this.delivery_man_type = 3;
        this.pickUpCheck = false;
        this.getSlotsDataWithAddress();
      } else {
        // this.pickUpCheck = true;
        this.getSlotsDataWithAddress();
      }
    }
    if (val === "4") {
      $(".isLocal").prop("checked", false);
      $(".isNation").prop("checked", false);
      $(".isPickUp").prop("checked", false);
      // this.delivery_man_type = 4;
      // this.pickUpCheck = false;
    }
    if (val === "5") {
      $(".isLocal").prop("checked", false);
      $(".isNation").prop("checked", false);
      $(".isDineIn").prop("checked", false);
      console.log(event.target.checked == true);
      if (event.target.checked == true) {
        $("#delivery_address").css("display", "none");
        this.delivery_man_type = 5;
        this.pickUpCheck = true;
        this.charges = 0;
        this.getSlotsDataWithAddress();
      } else {
        $("#delivery_address").css("display", "block");
        this.pickUpCheck = false;
        this.getSlotsDataWithAddress();
      }
    }
    if (
      $(".isLocal").prop("checked") === false &&
      $(".isNation").prop("checked") === false &&
      $(".isDineIn").prop("checked") === false &&
      $(".isPickUp").prop("checked") === false
    ) {
      this.delivery_man_type = 0;
    }
  }

  searchProductOnOrder() {
    clearTimeout(this.clearTimeoutProduct);
    this.clearTimeoutProduct = setTimeout(() => {
      this.nao.go(30);
      console.log("login data");
      this.dataService
        .searchProducts(
          window.localStorage.getItem("token"),
          this.searchString,
          this.dispensary_id
        )
        .subscribe(
          (data) => {
            this.nao.go(100);
            console.log("this.productData", this.productData);
            console.log("products data", data);
            if (this.searchString === "") {
              this.productData = [];
              this.productDataLength = undefined;
            } else {
              this.productData = data;
              // this.productData = this.productData.items;
              this.productDataLength = this.productData.length;
            }
          },
          (error) => {
            this.nao.go(100);
            console.log("error", error);
          }
        );
    }, 1000);
  }

  searchCustomerOnOrder() {
    clearTimeout(this.clearTimeoutCustomer);
    this.clearTimeoutCustomer = setTimeout(() => {
      this.nao.go(30);
      console.log("login data");
      this.dataService
        .searchCustomers(
          window.localStorage.getItem("token"),
          this.searchStringCustomer,
          this.dispensary_id
        )
        .subscribe(
          (data) => {
            this.nao.go(100);
            console.log("products data", data);
            if (this.searchStringCustomer === "") {
              this.customerData = [];
            } else {
              this.customerData = data;
              this.customerData = this.customerData.items;
              this.customerDataLength = this.customerData.length;
              for (var i = 0; i < this.customerData.length; i++) {
                if (this.customerData[i].country_code === "+1") {
                  this.customerData[i].phone_number = format(
                    this.customerData[i].phone_number,
                    "US",
                    "NATIONAL"
                  );
                  console.log(
                    "this.driverData[i].number",
                    this.customerData[i].phone_number
                  );
                }
              }
            }
          },
          (error) => {
            this.nao.go(100);
            console.log("error", error);
          }
        );
    }, 1000);
  }

  showmap() {
    const contax = this;
    $("#map2").css("display", "block");
    this.chRef.detectChanges();
    this.mapEle2 = this.mapElement2.nativeElement;

    var lat = this.outletData[0].latitude;
    var long = this.outletData[0].longitude;

    this.map2 = new google.maps.Map(this.mapEle2, {
      zoom: 13,
      center: { lat: lat, lng: long },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      zoomControl: true,
      scaleControl: true,
    });
    google.maps.event.addListenerOnce(this.map2, "idle", () => {
      this.mapEle2.classList.add("show-map");
    });
    var endImage = {
      url: "assets/drop_pin-bucket.png", // url
      scaledSize: new google.maps.Size(50, 56), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 16), // anchor
    };
    var orderDeliveryIcon = {
      url: "assets/pin-green.png", // url
      scaledSize: new google.maps.Size(30, 30), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 16), // anchor
    };
    var deliveryDriverIcon = {
      url: "assets/new-van.png", // url
      scaledSize: new google.maps.Size(40, 46), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 16), // anchor
    };
    setTimeout(() => {
      if (this.customerDisplayDataArray.length > 0) {
        if (this.customerDisplayDataArray[0].is_default === true) {
          console.log("in map functon", this.customerDisplayDataArray[0]);
          var boundsOrder = new google.maps.LatLngBounds();

          this.chRef.detectChanges();
          var latCustomer = Number(this.customerDisplayDataArray[0].latitude);
          var longCustomer = Number(this.customerDisplayDataArray[0].longitude);
          console.log("latCustomer, longCustomer", latCustomer, longCustomer);
          this.chRef.detectChanges();

          var locationDriver = new google.maps.LatLng(
            latCustomer,
            longCustomer
          );
          boundsOrder.extend(locationDriver);
          this.markerDrivers[0] = new google.maps.Marker({
            position: locationDriver,
            map: this.map2,
            icon: orderDeliveryIcon,
            zoom: 13,
          });
          this.chRef.detectChanges();
        }
      }
    }, 1000);
    setTimeout(() => {
      if (this.outletDisplayDataArray.length === 0) {
        if (this.outletNationWide === true) {
          if (this.outletData.length > 0) {
            for (var i = 0; i < this.outletData.length; i++) {
              if (
                this.outletData[i].outlet_type === 0 &&
                this.outletData[i].outlet_type === 0
              ) {
                var boundsOutlet = new google.maps.LatLngBounds();
                var locationOutlet = new google.maps.LatLng(
                  this.outletData[i].latitude,
                  this.outletData[i].longitude
                );
                boundsOutlet.extend(locationOutlet);
                this.markerDrivers[i] = new google.maps.Marker({
                  position: locationOutlet,
                  map: this.map2,
                  icon: endImage,
                  zoom: 13,
                });
              }
            }
          }
        }
        if (this.outletNationWide === false) {
          if (this.outletData.length > 0) {
            for (var i = 0; i < this.outletData.length; i++) {
              if (this.outletData[i].outlet_type === 0) {
                var boundsOutlet = new google.maps.LatLngBounds();
                var locationOutlet = new google.maps.LatLng(
                  this.outletData[i].latitude,
                  this.outletData[i].longitude
                );
                boundsOutlet.extend(locationOutlet);
                this.markerDrivers[i] = new google.maps.Marker({
                  position: locationOutlet,
                  map: this.map2,
                  icon: endImage,
                  zoom: 13,
                });
              }
            }
          }
        }
      } else {
        if (this.outletDisplayDataArray[0].outlet_type === 0) {
          var boundsOutlet = new google.maps.LatLngBounds();
          var locationOutlet = new google.maps.LatLng(
            this.outletDisplayDataArray[0].latitude,
            this.outletDisplayDataArray[0].longitude
          );
          boundsOutlet.extend(locationOutlet);
          this.markerDrivers[0] = new google.maps.Marker({
            position: locationOutlet,
            map: this.map2,
            icon: endImage,
            zoom: 13,
            center: {
              lat: this.outletDisplayDataArray[0].latitude,
              lng: this.outletDisplayDataArray[0].longitude,
            },
          });
        }
      }
    }, 1000);
  }

  // outletDisplayDataArray
  searchOutletOnOrder() {
    this.dispensary_id;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      console.log("login data");
      this.dataService
        .searchOutletsList(
          window.localStorage.getItem("token"),
          this.searchStringOutlet,
          this.dispensary_id
        )
        .subscribe(
          (data) => {
            console.log("products data", data);
            if (this.searchStringOutlet === "") {
              this.outletData = [];
            } else {
              this.outletData = data;
              this.outletNationWide = this.outletData.is_nation_wide;
              this.outletData = this.outletData.items;

              this.outletDataLength = this.outletData.length;
              for (var i = 0; i < this.outletData.length; i++) {
                if (this.outletData[i].country_code === "+1") {
                  this.outletData[i].phone_number = format(
                    this.outletData[i].phone_number,
                    "US",
                    "NATIONAL"
                  );
                  console.log(
                    "this.driverData[i].number",
                    this.outletData[i].phone_number
                  );
                }
              }
              console.log(
                this.outletData[0].latitude,
                this.outletData[0].longitude
              );
              this.outletDisplayDataArray = this.outletData; // zeeshan
              this.showDistance();
            }
          },
          (error) => {
            console.log("error", error);
          }
        );
    }, 1000);
  }

  openVariantModifiersPop(id, variantId, hasModifier) {
    if (hasModifier === true) {
      $("#addVariantsModifiersPop").modal("show");
      this.selectModifierProduct(id, variantId);
    } else {
      this.selectProduct(id, variantId);
    }
  }

  selectProduct(id, variantId) {
    this.searchString = "";
    console.log("id chk on slect product", id);
    console.log("product data on sleect product", this.productData);

    for (var i = 0; i < this.productDataLength; i++) {
      if (this.productData[i].id === id) {
        if (this.productData[i].variant[0].id === variantId) {
          var obj = {
            quantityTotal: 1,
            id: this.productData[i].id,
            name: this.productData[i].name,
            image: this.productData[i].image,
            variantName: this.productData[i].variant[0].option_name,
            optionValue: this.productData[i].variant[0].option_value,
            inventory_count: this.productData[i].inventory_count,
            cash_tax: this.productData[i].variant[0].cash_tax_percentage,
            card_tax: this.productData[i].variant[0].card_tax_percentage,
            price: Math.round(this.productData[i].variant[0].price),
            compare_price: Math.round(
              this.productData[i].variant[0].compare_price
            ),
            is_on_sale: this.productData[i].variant[0].is_on_sale,
            variant_id: this.productData[i].variant[0].id,
            error_msg: "",
          };

          // increment Value of Quntity..//
          var index: any;
          let returnObj = this.checkObjectVariant(
            this.productDisplayDataArray,
            obj
          );
          if (returnObj.value === false) {
            this.productDisplayDataArray.push(obj);
          } else {
            if (returnObj.index === -1) {
              index = this.productDisplayDataArray.indexOf(obj);
              this.productDisplayDataArray[index]["quantityTotal"] += 1;
            } else {
              this.productDisplayDataArray[returnObj.index][
                "quantityTotal"
              ] += 1;
            }
          }
          // const index = this.checkValUpdateVariant(this.productDisplayDataArray, obj);
          // this.productCalculation(this.productDisplayDataArray[index].variant_id, this.productDisplayDataArray[index].price, this.productDisplayDataArray[index].quantityTotal, index);
          this.reInitializeCalculationArray();
        }
      }
    }
    console.log("select product array", this.productDisplayDataArray);
    console.log(
      "customerDisplayDataArray in select customer",
      this.customerDisplayDataArray
    );
    if (this.customerDisplayDataArray.length > 0) {
      console.log("customerDisplayDataArray", this.customerDisplayDataArray);
      if (this.productDisplayDataArray.length === 1) {
        this.getSlotsDataWithAddress();
      }
    }
    let productLength = this.productDisplayDataArray.length;
    if (productLength != 0) {
      let updateCash = 0;
      let updateCard = 0;
      for (let i = 0; i < productLength; i++) {
        updateCash = this.productDisplayDataArray[i]["cash_tax"];
        updateCard = this.productDisplayDataArray[i]["card_tax"];
      }
      this.cash_tax = updateCash;
      this.card_tax = updateCard;
      this.tax_charges = updateCash || updateCard;
      if (this.cash_check == true) {
        this.paymentMethodOptionValue = 0;
        // this.tax_charges = this.cash_tax;
        this.tax_chargesToDisplay = this.cash_tax;
      }
      if (this.card_check == true) {
        this.paymentMethodOptionValue = 1;
        // this.tax_charges = this.card_tax;
        this.tax_chargesToDisplay = this.card_tax;
      }
    }
  }

  selectModifierProduct(id, _variantId) {
    this.searchString = "";
    this.productData.forEach((element) => {
      if (element.id === id) {
        console.log(element);
        let modifiers = [];
        let modPrices = 0;
        element.variant[0].modifiers.forEach((modElement) => {
          for (let i = 0; i < 1; i++) {
            modPrices += modElement.options[0].price;
          }
          modifiers.push(modElement);
        });
        let obj = {
          quantityTotal: 1,
          id: element.id,
          name: element.name,
          image: element.image,
          inventory_count: element.inventory_count,
          cash_tax: element.variant[0].cash_tax_percentage,
          card_tax: element.variant[0].card_tax_percentage,
          variantName: element.variant[0].option_name,
          optionValue: element.variant[0].option_value,
          price: Math.round(element.variant[0].price),
          compare_price: Math.round(element.variant[0].compare_price),
          is_on_sale: element.variant[0].is_on_sale,
          variant_id: element.variant[0].id,
          modifiers: modifiers,
          addons: element.variant[0].addons,
          noOption: element.variant[0].no_options,
          error_msg: "",
        };
        console.log(obj);
        let totalNoOptionPrice = 0;
        if (
          element.variant[0].no_options.length > 0 &&
          element.variant[0].no_options.options != null
        ) {
          for (
            let i = 0;
            i < element.variant[0].no_options.options.length;
            i++
          ) {
            totalNoOptionPrice =
              totalNoOptionPrice +
              element.variant[0].no_options.options[i].price;
            this.noOptionsPrice = totalNoOptionPrice;
          }
        }
        this.addItValue =
          Math.round(element.variant[0].price) + totalNoOptionPrice + modPrices;
        this.actualPrice = Math.round(element.variant[0].price);

        console.log(obj);
        this.productModifierDataArray = new Array();
        this.productModifierDataArray.push(obj);

        for (
          let i = 0;
          i < this.productModifierDataArray[0].modifiers.length;
          i++
        ) {
          for (let j = 0; j < 1; j++) {
            this.productModifierDataArray[0].modifiers[i].options[j].selected =
              true;
            this.modifiersArr.push({
              groupTitle: this.productModifierDataArray[0].modifiers[i].title,
              optionTitle:
                this.productModifierDataArray[0].modifiers[i].options[j].title,
              optionPrice:
                this.productModifierDataArray[0].modifiers[i].options[j].price,
            });
          }
        }
      }
    });
  }

  closeModal() {
    this.productData = [];
    this.addonsArr = [];
    this.noOptionsArr = [];
    this.modifiersArr = [];
    this.addItValue = 0;
    this.priceAddon = 0;
    this.actualPrice = 0;
    this.noOptionsPrice = 0;
    if (this.addonsArr.length > 0) {
      for (let i = 0; i < this.addonsArr.length; i++) {
        this.addonsArr[i].price = 0;
      }
    }
    for (
      let i = 0;
      i < this.productModifierDataArray[0].modifiers.length;
      i++
    ) {
      for (
        let j = 0;
        j < this.productModifierDataArray[0].modifiers[i].options.length;
        j++
      ) {
        if (
          this.productModifierDataArray[0].modifiers[i].options[j].selected ==
          true
        ) {
          this.productModifierDataArray[0].modifiers[i].options[j].price = 0;
          this.addItValue = 0;
        }
      }
    }
  }

  plusModifierValue(groupId, optionId) {
    console.log("Group ID", groupId);
    console.log("Option ID", optionId);
    this.priceAddon = 0;
    if (this.addonsArr.length > 0) {
      for (let i = 0; i < this.addonsArr.length; i++) {
        this.priceAddon = this.priceAddon + this.addonsArr[i].price;
      }
    }
    if (this.noOptionsPrice !== undefined) {
      this.addItValue =
        this.actualPrice + this.noOptionsPrice + this.priceAddon;
    } else {
      this.addItValue = this.actualPrice + this.priceAddon;
    }
    this.modifiersArr = [];
    for (
      let i = 0;
      i < this.productModifierDataArray[0].modifiers.length;
      i++
    ) {
      if (this.productModifierDataArray[0].modifiers[i].id == groupId) {
        for (
          let j = 0;
          j < this.productModifierDataArray[0].modifiers[i].options.length;
          j++
        ) {
          if (
            this.productModifierDataArray[0].modifiers[i].options[j].id ==
            optionId
          ) {
            this.productModifierDataArray[0].modifiers[i].options[j].selected =
              true;
          } else {
            this.productModifierDataArray[0].modifiers[i].options[j].selected =
              false;
          }
        }
      }
    }
    for (
      let i = 0;
      i < this.productModifierDataArray[0].modifiers.length;
      i++
    ) {
      for (
        let j = 0;
        j < this.productModifierDataArray[0].modifiers[i].options.length;
        j++
      ) {
        if (
          this.productModifierDataArray[0].modifiers[i].options[j].selected ==
          true
        ) {
          this.addItValue =
            this.addItValue +
            this.productModifierDataArray[0].modifiers[i].options[j].price;
          this.modifiersArr.push({
            groupTitle: this.productModifierDataArray[0].modifiers[i].title,
            optionTitle:
              this.productModifierDataArray[0].modifiers[i].options[j].title,
            optionPrice:
              this.productModifierDataArray[0].modifiers[i].options[j].price,
          });
          // console.log(this.productModifierDataArray[0].modifiers);
        }
      }
    }
    console.log(this.modifiersArr);
  }

  plusAddonsValue(value, title, event) {
    if (event.target.checked === true) {
      this.addItValue = this.addItValue + value;
      this.addonsArr.push({
        title: title,
        price: value,
      });
    } else if (event.target.checked === false) {
      this.addItValue = this.addItValue - value;
      for (var i = 0; i <= this.addonsArr.length - 1; i++) {
        if (this.addonsArr[i]["title"] == title) {
          this.addonsArr.splice(i, 1);
        }
      }
    }
    console.log(this.addonsArr);
  }

  subNoOptionValue(value, title, event) {
    if (event.target.checked === true) {
      for (var i = 0; i <= this.noOptionsArr.length - 1; i++) {
        if (this.noOptionsArr[i]["title"] == title) {
          this.noOptionsArr.splice(i, 1);
        }
      }
      this.addItValue = this.addItValue + value;
    } else if (event.target.checked === false) {
      this.noOptionsArr.push({
        title: title,
        price: value,
      });
      this.addItValue = this.addItValue - value;
    }
    console.log(this.noOptionsArr);
  }

  addItFunction(price) {
    console.log(this.productModifierDataArray);
    console.log(price);
    console.log(this.addonsArr);
    console.log(this.noOptionsArr);
    console.log(this.modifiersArr);
    this.productModifierDataArray.forEach((element) => {
      let obj = {
        quantityTotal: 1,
        id: element.id,
        name: element.name,
        image: element.image,
        inventory_count: element.inventory_count,
        cash_tax: element.cash_tax,
        card_tax: element.card_tax,
        variantName: element.variantName,
        optionValue: element.optionValue,
        price: this.addItValue,
        is_on_sale: element.is_on_sale,
        variant_id: element.variant_id,
        modifiers: this.modifiersArr,
        addons: this.addonsArr,
        noOption: this.noOptionsArr,
        hasModifier: true,
        error_msg: "",
      };

      // Checking Same Varient //
      var index: any;
      let returnObj = this.checkObjectModifier(
        this.productDisplayDataArray,
        obj
      );
      if (returnObj.value === false) {
        this.productDisplayDataArray.push(obj);
        index = this.productDisplayDataArray.indexOf(obj);
      } else {
        if (returnObj.index === -1) {
          index = this.productDisplayDataArray.indexOf(obj);
          this.productDisplayDataArray[index]["quantityTotal"] += 1;
        } else {
          index = returnObj.index;
          this.productDisplayDataArray[returnObj.index]["quantityTotal"] += 1;
        }
      }
      // let returnObj = this.checkObjectVariant(this.productDisplayDataArray, obj);
      // console.log(returnObj.value);
      // if (returnObj.value === false) {
      //   this.productDisplayDataArray.push(obj);
      // }
      // else{
      //   this.productDisplayDataArray[returnObj.index]['quantityTotal']+=1;
      // }
      // // this.productDisplayDataArray.push(obj);
      // // const index = this.checkValUpdateVariant(this.productDisplayDataArray, obj);
      // var index = -1;
      // if(returnObj.index === -1){
      //   index = this.productDisplayDataArray.indexOf(obj);
      // }
      // else{
      //   index = returnObj.index;
      // }
      // this.productDisplayDataArray.push(obj);
      // const index = this.productDisplayDataArray.indexOf(obj);

      // this.productCalculation(this.productDisplayDataArray[index].variant_id, this.productDisplayDataArray[index].price, this.productDisplayDataArray[index].quantityTotal, this.productDisplayDataArray[index].cash_tax, this.productDisplayDataArray[index].card_tax, index);
      this.reInitializeCalculationArray();
      $("#addVariantsModifiersPop").modal("hide");
      this.productModifierDataArray = [];
      this.modifiersArr = [];
      this.addonsArr = [];
      this.noOptionsArr = [];
    });
  }

  reInitializeCalculationArray() {
    this.calculationArray = [];
    this.productDisplayDataArray.forEach((element, index) => {
      this.productCalculation(
        element.variant_id,
        element.price,
        element.quantityTotal,
        element.cash_tax,
        element.card_tax,
        index
      );
    });
  }

  editQuantityOrder(_variantId, _price, quantity, index) {
    clearTimeout(this.clearTimeoutProduct);
    this.clearTimeoutProduct = setTimeout(() => {
      if (quantity == null) {
        this.productDisplayDataArray[index].quantity = 0;
      } else {
        this.productDisplayDataArray[index].quantity = quantity;
        this.reInitializeCalculationArray();
      }
    }, 1000);
  }

  editVariantName(variantId, name, variantOptionName) {
    this.variantName = name;
    this.varianId = variantId;
    this.variantOptionName = variantOptionName;
    $("#editVariantNamePop").modal("show");
  }

  updateVariantName(variantId) {
    if (this.variantNameCheck == "temporary") {
      for (let i = 0; i < this.productDisplayDataArray.length; i++) {
        if (variantId == this.productDisplayDataArray[i].variant_id) {
          this.productDisplayDataArray[i].optionValue = this.variantName;
          this.variantNameCheck = "temporary";
          $("#editVariantNamePop").modal("hide");
        }
      }
    } else {
      this.dataService
        .updatePrice(
          window.localStorage.getItem("token"),
          variantId,
          -1,
          this.variantName
        )
        .subscribe(
          (res) => {
            this.check = true;
            this.variantNameCheck = "temporary";
            if (res["success"] == true) {
              for (let i = 0; i < this.productDisplayDataArray.length; i++) {
                if (variantId == this.productDisplayDataArray[i].variant_id) {
                  this.check = false;
                  this.productDisplayDataArray[i].optionValue =
                    this.variantName;
                  $("#editVariantNamePop").modal("hide");
                }
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }

  editPrice(variantId, productObj) {
    console.log(productObj);
    if (productObj["hasModifier"] == true) {
      let price = productObj["price"];
      if (productObj["addons"] != null && productObj["addons"].length > 0) {
        for (let i = 0; i < productObj["addons"].length; i++) {
          price = price - productObj.addons[i].price;
        }
      }
      if (
        productObj["modifiers"] != null &&
        productObj["modifiers"].length > 0
      ) {
        for (let i = 0; i < productObj["modifiers"].length; i++) {
          price = price - productObj.modifiers[i].optionPrice;
        }
      }
      this.variantPrice = price;
      this.varianId = variantId;
    } else {
      this.variantPrice = productObj["price"];
      this.varianId = variantId;
    }
    $("#editPricePop").modal("show");
  }

  updateVariantPrice(variantId) {
    if (this.changeCheck == "temporary") {
      for (let i = 0; i < this.productDisplayDataArray.length; i++) {
        if (variantId == this.productDisplayDataArray[i].variant_id) {
          let price = parseInt(this.variantPrice);
          if (
            this.productDisplayDataArray[i].addons != null &&
            this.productDisplayDataArray[i].addons.length > 0
          ) {
            for (
              let j = 0;
              j < this.productDisplayDataArray[i].addons.length;
              j++
            ) {
              price = price + this.productDisplayDataArray[i].addons[j].price;
            }
          }
          if (
            this.productDisplayDataArray[i].modifiers != null &&
            this.productDisplayDataArray[i].modifiers.length > 0
          ) {
            for (
              let j = 0;
              j < this.productDisplayDataArray[i].modifiers.length;
              j++
            ) {
              price =
                price +
                this.productDisplayDataArray[i].modifiers[j].optionPrice;
            }
          }
          this.productDisplayDataArray[i].price = price;
          this.productDisplayDataArray[i].changeCheck = this.changeCheck;
          this.productDisplayDataArray[i].updatedVariantPrice =
            this.variantPrice;
          this.changeCheck = "temporary";
          this.reInitializeCalculationArray();
          $("#editPricePop").modal("hide");
          console.log(this.productDisplayDataArray);
        }
      }
    } else {
      this.dataService
        .updatePrice(
          window.localStorage.getItem("token"),
          variantId,
          this.variantPrice,
          ""
        )
        .subscribe(
          (res) => {
            this.check = true;
            this.changeCheck = "temporary";
            if (res["success"] == true) {
              for (let i = 0; i < this.productDisplayDataArray.length; i++) {
                if (variantId == this.productDisplayDataArray[i].variant_id) {
                  let price = res["variant"].price;
                  if (
                    this.productDisplayDataArray[i].addons != null &&
                    this.productDisplayDataArray[i].addons.length > 0
                  ) {
                    for (
                      let j = 0;
                      j < this.productDisplayDataArray[i].addons.length;
                      j++
                    ) {
                      price =
                        price + this.productDisplayDataArray[i].addons[j].price;
                    }
                  }
                  if (
                    this.productDisplayDataArray[i]["modifiers"] != null &&
                    this.productDisplayDataArray[i].modifiers.length > 0
                  ) {
                    for (
                      let j = 0;
                      j < this.productDisplayDataArray[i].modifiers.length;
                      j++
                    ) {
                      price =
                        price +
                        this.productDisplayDataArray[i].modifiers[j]
                          .optionPrice;
                    }
                  }
                  this.check = false;
                  this.productDisplayDataArray[i].price = price;
                  this.productDisplayDataArray[i].changeCheck =
                    this.changeCheck;
                  this.reInitializeCalculationArray();
                  $("#editPricePop").modal("hide");
                  console.log(variantId);
                }
              }
            }
            console.log(res);
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }

  selectedProductRemove(index, id) {
    console.log("index", index);

    console.log("id", id);
    if (this.cash_check == true) {
      this.tax_chargesToDisplay =
        this.tax_chargesToDisplay -
        this.productDisplayDataArray[index]["cash_tax"];
    }
    if (this.card_check == true) {
      this.tax_chargesToDisplay =
        this.tax_chargesToDisplay -
        this.productDisplayDataArray[index]["card_tax"];
    }
    this.productDisplayDataArray.splice(index, 1);

    // console.log('this.productDisplayDataArray', this.productDisplayDataArray);
    // this.productDataLength = this.productDisplayDataArray.length;
    this.reInitializeCalculationArray();
    // console.log('productDisplayDataArray', this.productDisplayDataArray, this.productDataLength);
    // var indexTemp = this.checkValUpdateById(this.calculationArray, id);
    // console.log('indexTemp', indexTemp);
    // this.calculationArray.splice(indexTemp, 1);
    // console.log('calculationArray', this.calculationArray);
    setTimeout(() => {
      if (this.productDisplayDataArray.length === 0) {
        this.slotSuccessMessage = "";
        this.timeSlotDetail_delivery = [];
        var emptyArray = [];
        this.timeSlotDetail_delivery_show = JSON.parse(
          JSON.stringify(emptyArray)
        );
        this.dayOfGivenTime = "";
        this.overnight = "";
        this.timeSlotDetail = null;
        this.dayIndex = null;
        this.outletIdToSendInCheckout = null;
        this.third_party_string = "";
        this.time = null;
        this.businessTypeFromSlotRequest = null;
        this.timeSlotDetail_delivery_charges = 0;
        this.platformFeeData.delivery_charges =
          this.timeSlotDetail_delivery_charges;
        if (this.pickUpCheck == true) {
          this.charges = 0;
        } else {
          this.charges =
            this.platformFeeData.delivery_charges +
            this.platformFeeData.platform_fee;
        }
        this.totalPrice = 0;
        this.discountFunction();
      }
      this.calculateTotalPrice();
      this.discountFunction();
      this.chargesFunction();
    }, 50);
  }

  selectCustomer(id) {
    this.customerDisplayDataArray = [];
    localStorage.setItem("client_id", id);
    for (var i = 0; i < this.customerDataLength; i++) {
      if (this.customerData[i].id === id) {
        this.selectedCustomerId = id;
        this.selectedCustomerObj = this.customerData[i];
        console.log("address_list", this.selectedCustomerObj);
        this.freeCount = this.selectedCustomerObj.free_delivery_count;
        this.customerAddressList =
          this.selectedCustomerObj.address_list.address_dictionary;
        this.customerDisplayDataArray.push({
          id: this.selectedCustomerObj.id,
          first_name: this.selectedCustomerObj.first_name,
          last_name: this.selectedCustomerObj.last_name,
          payments: this.selectedCustomerObj.payments,
          email: this.selectedCustomerObj.email,
          country_code: this.selectedCustomerObj.country_code,
          phone_number: this.selectedCustomerObj.phone_number,
          address: "",
          street: "",
          city: "",
          state: "",
          area: "",
          zip: "",
          apart_no: "",
          longitude: 0,
          latitude: 0,
          is_default: false,
          place_label: "",
          house_building_no: "",
          address_id: null,
        });
        for (
          var j = 0;
          j < this.selectedCustomerObj.address_list.address_dictionary.length;
          j++
        ) {
          if (
            this.selectedCustomerObj.address_list.address_dictionary[j]
              .is_default === true
          ) {
            this.customerDisplayDataArray = [];
            this.customerDisplayDataArray.push({
              id: this.selectedCustomerObj.id,
              first_name: this.selectedCustomerObj.first_name,
              last_name: this.selectedCustomerObj.last_name,
              payments: this.selectedCustomerObj.payments,
              email: this.selectedCustomerObj.email,
              country_code: this.selectedCustomerObj.country_code,
              phone_number: this.selectedCustomerObj.phone_number,
              address:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .address_line1,
              street:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .address_line1,
              city: this.selectedCustomerObj.address_list.address_dictionary[j]
                .city,
              state:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .state,
              area: this.selectedCustomerObj.address_list.address_dictionary[j]
                .country,
              zip: this.selectedCustomerObj.address_list.address_dictionary[j]
                .zip,
              apart_no:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .apart_no,
              longitude:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .longitude,
              latitude:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .latitude,
              is_default:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .is_default,
              place_label:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .place_label,
              house_building_no:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .house_building_no,
              address_id:
                this.selectedCustomerObj.address_list.address_dictionary[j].id,
            });
            this.showDistance();
          }
        }
      }
    }

    this.getPayementCard();
    if (this.productDisplayDataArray.length > 0) {
      this.getSlotsDataWithAddress();
    }
    // this.CustomerSearchBox = false;
    $(".CustomerSearchBoxHide").css("display", "block");
    $(".CustomerSearchBoxShow").css("display", "none");
    $("#paymentNoCheck-1").css("display", "none");

    this.chRef.detectChanges();
  }

  selectAddressCustomerFun(address) {
    this.dataService
      .setPrimaryCustomerAddress(
        window.localStorage.getItem("token"),
        this.selectedCustomerObj.id,
        address.id
      )
      .subscribe(
        (_data) => {
          var number = this.selectedCustomerObj.id;
          // var number =  this.selectedCustomerObj.country_code + this.selectedCustomerObj.phone_number;
          // number = number.replace('(', '');
          // number = number.replace(')', '');
          // number = number.replace('-', '');
          // number = number.replace(/\s/g, '');
          this.prefindCustomerForDisplayData(number);
        },
        (error) => {
          console.log("error", error);
        }
      );
  }

  deliveryMethodConform(id, value) {
    console.log(id, value);
    console.log(this.productDisplayDataArray);
    let productLength = this.productDisplayDataArray.length;
    if (productLength > 0) {
      let updateCash = 0;
      let updateCard = 0;
      for (let i = 0; i < productLength; i++) {
        updateCash += this.productDisplayDataArray[i]["cash_tax"];
        updateCard += this.productDisplayDataArray[i]["card_tax"];
      }
      this.cash_tax = updateCash;
      this.card_tax = updateCard;
    }

    if (this.preventCall === false) {
      console.log("this.showPaymentView1", this.showPaymentView);
      if (this.showPaymentView === false) {
        console.log("this.showPaymentView2", this.showPaymentView);
        return;
      }
      $("#paymentNoCheck-cash").css("display", "none");
      this.cash_check = false;
      if (this.paymentCardData.length > 0) {
        for (let i = 0; i < this.paymentCardData.length; i++) {
          $("#paymentNoCheck" + i).css("display", "none");
        }
      }
      if (value === -1) {
        this.paymentMethodOptionValue = 0;
        $("#paymentNoCheck-cash").css("display", "inline-block");
        $("#paymentNoCheck-mpos").css("display", "none");
        $("#paymentNoCheck-bank").css("display", "none");
        $("#paymentNoCheck-alreadyPaid").css("display", "none");
        this.card_check = false;
        this.cash_check = true;
        this.bank_check = false;
        this.mos_check = false;
        this.already_paid = false;
        console.log("paymentMethodOptionValue", this.paymentMethodOptionValue);
      } else if (value === -2) {
        this.paymentMethodOptionValue = 2;
        $("#paymentNoCheck-bank").css("display", "inline-block");
        $("#paymentNoCheck-cash").css("display", "none");
        $("#paymentNoCheck-mpos").css("display", "none");
        $("#paymentNoCheck-alreadyPaid").css("display", "none");
        this.bank_check = true;
        this.cash_check = true;
        this.card_check = false;
        this.mos_check = false;
        this.already_paid = false;
      } else if (value == -3) {
        this.paymentMethodOptionValue = 3;
        $("#paymentNoCheck-mpos").css("display", "inline-block");
        $("#paymentNoCheck-bank").css("display", "none");
        $("#paymentNoCheck-cash").css("display", "none");
        $("#paymentNoCheck-alreadyPaid").css("display", "none");
        this.mos_check = true;
        this.card_check = true;
        this.cash_check = false;
        this.bank_check = false;
        this.already_paid = false;
      } else if (value == 4) {
        this.paymentMethodOptionValue = 4;
        $("#paymentNoCheck-mpos").css("display", "none");
        $("#paymentNoCheck-bank").css("display", "none");
        $("#paymentNoCheck-cash").css("display", "none");
        $("#paymentNoCheck-alreadyPaid").css("display", "none");
        this.mos_check = false;
        this.card_check = false;
        this.cash_check = true;
        this.bank_check = false;
        this.already_paid = true;
      } else if (value == 5) {
        this.paymentMethodOptionValue = 5;
        $("#paymentNoCheck-mpos").css("display", "none");
        $("#paymentNoCheck-bank").css("display", "none");
        $("#paymentNoCheck-cash").css("display", "none");
        $("#paymentNoCheck-alreadyPaid").css("display", "none");
        this.mos_check = false;
        this.card_check = true;
        this.cash_check = false;
        this.bank_check = false;
        this.already_paid = true;
      } else if (value == -4) {
        this.paymentMethodOptionValue = 4;
        $("#paymentNoCheck-alreadyPaid").css("display", "inline-block");
        $("#paymentNoCheck-mpos").css("display", "none");
        $("#paymentNoCheck-bank").css("display", "none");
        $("#paymentNoCheck-cash").css("display", "none");
        this.mos_check = false;
        this.card_check = true;
        this.cash_check = false;
        this.bank_check = false;
        this.already_paid = true;
      } else {
        this.cash_check = false;
        this.card_check = true;
        this.bank_check = false;
        this.mos_check = false;
        this.already_paid = false;
        this.paymentMethodOptionValue = 1;
        this.nao.go(30);
        this.preventCall = false;
        this.dataService
          .makePaymentMethodPrimaryCustomer(
            window.localStorage.getItem("token"),
            id,
            this.customerDisplayDataArray[0].id
          )
          .subscribe(
            (data) => {
              this.nao.go(100);
              this.primaryDataSuccess = data;
              if (this.primaryDataSuccess.success === true) {
                toastr.success(this.primaryDataSuccess.message);
                for (let i = 0; i < this.paymentCardData.length; i++) {
                  this.paymentCardData[i].primary = false;
                  $("#paymentNoCheck" + i).css("display", "none");
                  $("#paymentNoCheck-bank").css("display", "none");
                  $("#paymentNoCheck-mpos").css("display", "none");
                  $("#paymentNoCheck-alreadyPaid").css("display", "none");
                }
                $("#paymentNoCheck" + value).css("display", "inline");
                this.paymentCardData[value].primary = true;
                this.preventCall = false;
              }
            },
            (_error) => {
              this.nao.go(100);
              toastr.error("Some thing went wrong");
            }
          );
      }
    }
    if (this.already_paid == true) {
      if (this.cash_check == true) {
        this.paymentMethodOptionValue = 4;
      }
    }
    if (this.cash_check == true) {
      if (this.bank_check == true) {
        this.paymentMethodOptionValue = 2;
      }

      if (this.bank_check == false && this.already_paid == false) {
        this.paymentMethodOptionValue = 0;
      }
      // this.tax_charges = this.cash_tax;
      this.tax_chargesToDisplay = this.cash_tax;
      this.tax_charges = this.cash_tax;
      console.log(
        "Cash Tax////////////////////////////////",
        this.tax_chargesToDisplay
      );
    }
    if (this.already_paid == true) {
      if (this.card_check == true) {
        this.paymentMethodOptionValue = 5;
      }
    }

    if (this.card_check == true) {
      if (this.mos_check == true) {
        this.paymentMethodOptionValue = 3;
      }
      if (this.mos_check == false && this.already_paid == false) {
        this.paymentMethodOptionValue = 1;
      }
      // this.tax_charges = this.card_tax;
      this.tax_chargesToDisplay = this.card_tax;
      this.tax_charges = this.card_tax;
    }
    // if (this.already_paid == true) {
    //   this.paymentMethodOptionValue = 4;
    // }
    this.reInitializeCalculationArray();
    setTimeout(() => {
      this.calculateTotalPrice();
    }, 500);
  }

  openPaymentListingPopup() {
    this.cardNum = "";
    this.cardName = "";
    this.expiryDate = "";
    this.card_cvv = "";
    $("#expiry").css("border-color", "#ccc");
    // this.getPayementCard();
    // $('#paymentPopup').modal('show');
    $(".jp-card-number").empty();
    $(".jp-card-name").empty();
    $(".jp-card-expiry").empty();
    $(".jp-card-cvc").empty();
    $(".jp-card-number").text("•••• •••• •••• ••••");
    $(".jp-card-name").text("Full Name");
    $(".jp-card-expiry").text("••/••");

    $("#addPaymentPop").modal("show");
  }

  getPayementCard() {
    this.showPaymentView = false;
    console.log("showPaymentView 1", this.showPaymentView);
    // this.nao.go(30);
    this.dataService
      .getPaymentMethodlist(
        window.localStorage.getItem("token"),
        this.customerDisplayDataArray[0].id
      )
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.paymentCardData = data;
          this.paymentCardData = this.paymentCardData.Dictionary_Payment_List;

          setTimeout(() => {
            if (
              this.paymentThroughCash === "true" &&
              this.paymentThroughCard === "true"
            ) {
              this.paymentMethodOptionValue = -1;
            }
            if (
              this.paymentThroughCash === "true" &&
              this.paymentThroughCard === "false"
            ) {
              $("#paymentNoCheck-cash").css("display", "inline");
              this.cash_check = true;
              this.card_check = false;
              this.paymentMethodOptionValue = 0;
            }
            console.log(this.paymentThroughCash, this.paymentThroughCard);
            if (
              this.paymentThroughCash === "false" &&
              this.paymentThroughCard === "true"
            ) {
              this.paymentMethodOptionValue = 1;
              for (let i = 0; i < this.paymentCardData.length; i++) {
                if (this.paymentCardData[i].primary === true) {
                  $("#paymentNoCheck" + i).css("display", "inline");
                  this.card_check = true;
                  this.cash_check = false;
                }
              }
              if (this.paymentCardData.length === 0) {
                this.paymentMethodOptionValue = -1;
              }
            }
            this.showPaymentView = true;
            console.log("showPaymentView 2", this.showPaymentView);
          }, 1000);

          // $('.clearPrimary').css('display', 'none');
          // for ( let i = 0; i < this.paymentCardData.length; i++ ) {
          //   if ( this.paymentCardData[i].primary === true ) {
          //     console.log('in primary', i);
          //     $('#paymentNoPrimery' + i).css('display', 'inline-block');
          //   }
          // }
        },
        (_error) => {
          // this.nao.go(100);
        }
      );
  }

  removeCardConformPopup(id) {
    this.deleteCardNoId = id;
    $("#removeCardConformPop").modal("show");
  }

  conformRemovefun(id) {
    this.disabledClick = true;
    $("#removeCardConformPop").modal("hide");
    this.dataService
      .removePaymentMethodOfCustomer(
        window.localStorage.getItem("token"),
        id,
        this.customerDisplayDataArray[0].id
      )
      .subscribe(
        (data) => {
          this.removeCardData = data;
          if (this.removeCardData.success === false) {
            toastr.error(this.removeCardData.message);
          }
          if (this.removeCardData.success === true) {
            toastr.success(this.removeCardData.message);
          }
          this.disabledClick = false;
          this.getPayementCard();
        },
        (_error) => {
          this.disabledClick = false;
        }
      );
  }

  makePaymentMethodPrimaryFunction(id, cardNumber, index) {
    this.customerPrimeryCardNo = cardNumber;
    for (let i = 0; i <= this.paymentCardData.length; i++) {
      $("#primary" + i).prop("checked", false);
    }
    this.nao.go(30);
    this.dataService
      .makePaymentMethodPrimaryCustomer(
        window.localStorage.getItem("token"),
        id,
        this.customerDisplayDataArray[0].id
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.primaryDataSuccess = data;
          if (this.primaryDataSuccess.success === true) {
            toastr.success(this.primaryDataSuccess.message);
            $("#primary" + index).prop("checked", true);
          }
        },
        (_error) => {
          this.nao.go(100);
          toastr.error("Some thing went wrong");
        }
      );
  }

  openPaymentPop() {
    this.cardNum = "";
    this.cardName = "";
    this.expiryDate = "";
    this.card_cvv = "";
    $(".clr").css("border-color", "#ccc");
    $(".jp-card-number").empty();
    $(".jp-card-name").empty();
    $(".jp-card-expiry").empty();
    $(".jp-card-cvc").empty();
    $(".jp-card-number").text("•••• •••• •••• ••••");
    $(".jp-card-name").text("Full Name");
    $(".jp-card-expiry").text("••/••");
    $("#addPaymentPop").modal("show");
  }

  expiryDateValidation() {
    this.expiryDateError = 0;
    var splitMonth = this.expiryDate.split("/")[0];
    console.log("splitMonth", splitMonth);
    var splitLastWord = this.expiryDate.split("/").splice(-2)[1];
    splitLastWord = this.expiryDate.split(" ").splice(-2)[1];
    // console.log('splitLastWord.length', splitLastWord.length);
    var year = new Date().getFullYear();
    // year = splitLastWord;
    var yearFinal = year.toString();
    console.log("date", year);
    if (splitLastWord.length === undefined) {
      this.expiryDateError++;
      return;
    }
    if (parseInt(splitMonth, 10) > 12) {
      console.log("month invalid");
      this.expiryDateError++;
    }
    if (splitLastWord.length !== undefined) {
      if (splitLastWord.length === 2) {
        var last = yearFinal[yearFinal.length - 1];
        var second = yearFinal[yearFinal.length - 2];
        var final = second + last;
        console.log("in 2", splitLastWord);
        console.log("final", final);
        if (splitLastWord >= final) {
          console.log("date is valid");
          $("#expiry").css("border-color", "#ccc");
        } else {
          console.log("date is not valid");
          // $('#expiry').css('border-color', '#eb3b3b');
          this.expiryDateError++;
        }
      } else if (splitLastWord.length === 4) {
        console.log("in 4 splitLastWord", splitLastWord);
        console.log("in 4 year", yearFinal);
        if (splitLastWord >= yearFinal) {
          console.log("date is valid");
          // $('#expiry').css('border-color', '#ccc');
        } else {
          console.log("date is not valid");
          // $('#expiry').css('border-color', '#eb3b3b');
          this.expiryDateError++;
        }
      } else {
        // $('#expiry').css('border-color', '#eb3b3b');
        this.expiryDateError++;
      }
    } else {
      // $('#expiry').css('border-color', '#eb3b3b');
      this.expiryDateError++;
    }
    if (this.expiryDateError > 0) {
      $("#expiry").css("border-color", "#eb3b3b");
    } else {
      $("#expiry").css("border-color", "#ccc");
    }
  }

  checkCardType(number) {
    // visa
    var re = new RegExp("^4");
    if (number.match(re) != null) {
      // return 'Visa';
      return "4";
    }

    // Mastercard
    // Updated for Mastercard 2017 BINs expansion
    if (
      /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
        number
      )
    ) {
      // return 'Mastercard';
      return "5";
    }

    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null) {
      // return 'AMEX';
      return "2";
    }

    // Discover
    re = new RegExp(
      "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)"
    );
    if (number.match(re) != null) {
      // return 'Discover';
      return "6";
    }

    // Diners
    re = new RegExp("^36");
    if (number.match(re) != null) {
      // return 'Diners';
      return "7";
    }
    // Diners - Carte Blanche
    re = new RegExp("^30[0-5]");
    if (number.match(re) != null) {
      // return 'Diners - Carte Blanche';
      return "7";
    }

    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (number.match(re) != null) {
      // return 'JCB';
      return "3";
    }

    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (number.match(re) != null) {
      // return 'Visa Electron';
      return "4";
    }

    return "0";
  }

  addPaymentMethodFunction() {
    var error_count = 0;
    $(".clr").css("border-color", "#ccc");
    if (this.cardNum === "") {
      $("#number").css("border-color", "#eb3b3b");
      error_count++;
    }
    if (this.cardName === "") {
      $("#name").css("border-color", "#eb3b3b");
      error_count++;
    }
    if (this.expiryDate === "") {
      $("#expiry").css("border-color", "#eb3b3b");
      error_count++;
    }
    if (this.card_cvv === "") {
      $("#cvc").css("border-color", "#eb3b3b");
      error_count++;
    }
    if (error_count > 0) {
      return;
    }
    if (this.expiryDateError > 0) {
      $("#expiry").css("border-color", "#eb3b3b");
      toastr.error("Expiry date is not valid");
      return;
    }
    this.disabledClick = true;
    this.cardType = this.checkCardType(this.cardNum);
    this.nao.go(30);
    this.dataService
      .addPaymentMethodCustomer(
        window.localStorage.getItem("token"),
        this.cardNum,
        this.cardName,
        this.expiryDate,
        this.card_cvv,
        this.customerDisplayDataArray[0].id,
        this.cardType
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.cardSuccess = data;
          this.cardMessage = this.cardSuccess.message;
          this.cardSuccess = this.cardSuccess.success;
          if (this.cardSuccess === true) {
            toastr.success("Card Added Successfully");
            this.cardNum = "";
            this.cardName = "";
            this.expiryDate = "";
            this.card_cvv = "";
            this.getPayementCard();
            $("#addPaymentPop").modal("hide");
          } else {
            toastr.error(this.cardMessage);
          }
          this.disabledClick = false;
        },
        (_error) => {
          this.nao.go(100);
          this.disabledClick = false;
          toastr.error("Some thing went wrong");
        }
      );
  }

  selectOutlet(id) {
    console.log("select Outlet called, array is set to empty.");
    console.log("Outlet Array is ===== > ", this.outletData);
    this.outletDisplayDataArray = [];
    console.log("outletDataLength", this.outletDataLength);
    for (var i = 0; i < this.outletDataLength; i++) {
      if (this.outletData[i].id === id) {
        this.outletDisplayDataArray.push({
          id: this.outletData[i].id,
          name: this.outletData[i].name,
          email: this.outletData[i].email,
          phone_number:
            this.outletData[i].country_code +
            " " +
            this.outletData[i].phone_number,
          address: this.outletData[i].address_line1,
          city: this.outletData[i].city,
          street: this.outletData[i].street,
          state: this.outletData[i].state,
          area: this.outletData[i].area,
          zip: this.outletData[i].zip,
          longitude: this.outletData[i].longitude,
          latitude: this.outletData[i].latitude,
          outlet_type: this.outletData[i].outlet_type,
        });
      }
    }
    console.log("selected outlet. shani", this.outletDisplayDataArray);
    this.showDistance();
    this.outletSearchBox = false;
    console.log("outlet display data shani", this.outletDisplayDataArray);
  }

  productCalculation(id, price, quantity, cash_tax, card_tax, _index) {
    console.log(cash_tax, card_tax);
    if (quantity === null) {
      // this.productDisplayDataArray[index].quantityTotal = 1;
      quantity = 0;
    }
    let charges = 0;
    if (this.card_check == true) {
      charges = card_tax;
    }
    if (this.cash_check == true) {
      charges = cash_tax;
    }
    console.log("id", id);
    this.fieldDisable = false;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // var obj = {
      //   id: id,
      //   total_price: price * quantityget
      // };
      // if (this.checkObject(this.calculationArray, obj) === false) {
      //   this.calculationArray.push(obj);
      // } else {
      //   var objIndex = this.checkValUpdate(this.calculationArray, obj);
      //   this.calculationArray[objIndex].total_price = this.calculationArray[objIndex].total_price + (price * quantity);
      //   console.log('this.calculationArray[objIndex].total_price', this.calculationArray[objIndex].total_price);
      // }
      // console.log('this.calculationArray', this.calculationArray);
      // this.calculateTotalPrice();
      // // if (this.discount !== 0)
      // this.discountFunction();
      // this.chargesFunction();
    }, 300);
    setTimeout(() => {
      if (quantity > 0) {
        var obj = {
          id: id,
          total_price: price * quantity,
          tax_charges: charges,
        };
        //quantity = this.productDisplayDataArray[index].quantityTotal;
        if (this.checkObject(this.calculationArray, obj) === false) {
          this.calculationArray.push(obj);
        } else {
          var objIndex = this.checkValUpdate(this.calculationArray, obj);
          this.calculationArray[objIndex].total_price += price * quantity;
          this.calculationArray[objIndex].tax_charges =
            this.calculationArray[objIndex].tax_charges;
          console.log(
            "this.calculationArray[objIndex].total_price",
            this.calculationArray[objIndex].total_price
          );
        }
        console.log("this.calculationArray", this.calculationArray);
        this.calculateTotalPrice();
        // if (this.discount !== 0)
        this.discountFunction();
        this.chargesFunction();

        this.getSlotsDataWithAddress();
      }
    }, 700);
  }

  preventMinus(e) {
    console.log("e value", e);
    var inputKeyCode = e.keyCode ? e.keyCode : e.which;
    if (inputKeyCode != null) {
      if (inputKeyCode === 45) e.preventDefault();
    }
  }

  updateChargesWhenUpdateDiscount() {
    setTimeout(() => {
      this.getSlotsDataWithAddress();
    }, 700);
  }

  discountFunction() {
    this.totalPrice = this.totalPriceDiscount;
    this.tax_chargesToDisplay = Math.round(this.tax_chargesToDisplay);
    var disSubTotal =
      ((this.totalPrice - this.tax_chargesToDisplay) * this.discount) / 100;
    disSubTotal = Math.round(disSubTotal);
    this.subTotal = this.tax_chargesToDisplay
      ? this.totalPrice - this.tax_chargesToDisplay
      : this.totalPrice;
    this.subTotal = Math.round(this.subTotal);
    this.totalPrice = this.discount
      ? this.totalPrice - disSubTotal
      : this.totalPrice;
    this.totalPrice = Math.round(this.totalPrice);
    this.myTemp = this.totalPrice;
    this.myTemp = Math.round(this.myTemp);
    this.chargesFunction();
  }

  chargesFunction() {
    this.charges = Math.round(this.charges);
    // clearTimeout(this.clearTimeout);
    // this.clearTimeout = setTimeout(() => {

    this.totalPrice = this.myTemp;
    if (this.discount === "" || this.discount === 0) {
      this.totalPrice = this.totalPriceDiscount;
      console.log("if", this.totalPrice);
    } else {
      // var temp = this.totalPrice * this.tax_charges / 100;
      // this.totalPrice = this.subTotal + this.mycharges;
      // this.totalPrice = this.totalPriceDiscount;
      // this.totalPrice = this.totalPrice + this.charges;
      console.log("else", this.totalPrice);
    }

    this.totalPrice = this.totalPrice + this.charges;
    console.log("totalPrice chargesFunction", this.totalPrice);
    // }, 500);
  }

  checkObject(array, obj) {
    var value = false;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === obj.id) {
        value = true;
        break;
      }
    }
    return value;
  }

  checkObjectVariant(array, obj) {
    var value = false;
    var index = -1;
    for (var i = 0; i < array.length; i++) {
      if (array[i].variant_id === obj.variant_id) {
        if (array[i].id === obj.id) {
          value = true;
          index = i;
          break;
        }
      }
    }
    obj = {
      value: value,
      index: index,
    };
    return obj;
  }

  checkObjectModifier(array, obj) {
    var value = false;
    var index = -1;
    for (var i = 0; i < array.length; i++) {
      if (array[i].variant_id === obj.variant_id) {
        if (array[i].id === obj.id) {
          if (
            JSON.stringify(array[i].addons) == JSON.stringify(obj.addons) &&
            JSON.stringify(array[i].modifiers) ==
              JSON.stringify(obj.modifiers) &&
            JSON.stringify(array[i].noOption) == JSON.stringify(obj.noOption)
          ) {
            value = true;
            index = i;
            break;
          }
        }
      }
    }
    obj = {
      value: value,
      index: index,
    };
    return obj;
  }

  checkValUpdate(array, obj) {
    var value = -1;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === obj.id) {
        value = i;
        break;
      }
    }
    return value;
  }

  checkValUpdateVariant(array, obj) {
    var value = -1;
    for (var i = 0; i < array.length; i++) {
      if (array[i].variant_id === obj.variant_id) {
        value = i;
        break;
      }
    }
    return value;
  }

  checkValUpdateById(array, id) {
    var value = -1;
    for (var i = 0; i < array.length; i++) {
      console.log("array[i].id", array[i].id);
      if (array[i].id === id) {
        value = i;
        break;
      }
    }
    return value;
  }

  calculateTotalPrice() {
    console.log("this.calculationArray", this.calculationArray);
    this.totalPrice = 0;
    this.tax_chargesToDisplay = 0;
    console.log(this.calculationArray);
    for (var i = 0; i < this.calculationArray.length; i++) {
      this.totalPrice += this.calculationArray[i].total_price;
      this.tax_chargesToDisplay +=
        (this.calculationArray[i].tax_charges *
          this.calculationArray[i].total_price) /
        100;
    }
    console.log(this.tax_chargesToDisplay);
    // this.totalPrice = Math.round(this.totalPrice);

    this.mycharges = (this.totalPrice * this.tax_charges) / 100;

    this.mycharges = Math.floor(this.mycharges);
    // this.tax_chargesToDisplay = this.mycharges;
    this.totalPriceDiscount = this.totalPrice + this.tax_chargesToDisplay;

    this.totalPriceDiscount = Math.round(this.totalPriceDiscount);
  }
  closeCustomerDetailBox() {
    this.showBreakdownIcon = false;
    this.freeCount = 0;
    this.CustomerSearchBox = true;
    this.editAddress = false;
    this.customerDisplayDataArray = [];
    this.closeOutletDetailBox();
    this.timeSlotDetail_delivery_charges = 0;
    this.platformFeeData.delivery_charges =
      this.timeSlotDetail_delivery_charges;
    if (this.pickUpCheck == true) {
      this.charges = 0;
    } else {
      this.charges =
        this.platformFeeData.delivery_charges +
        this.platformFeeData.platform_fee;
    }
    this.discountFunction();
    this.showDistance();
    $(".CustomerSearchBoxHide").css("display", "none");
    $(".CustomerSearchBoxShow").css("display", "block");
    $(".editAddressHide").css("display", "none");
    $(".editAddressShow").css("display", "block");

    setTimeout(() => {
      this.slotSuccessMessage = "";
      this.timeSlotDetail_delivery = [];
      var emptyArray = [];
      this.timeSlotDetail_delivery_show = JSON.parse(
        JSON.stringify(emptyArray)
      );
      this.dayOfGivenTime = "";
      this.overnight = "";
      this.timeSlotDetail = null;
      this.dayIndex = null;
      this.outletIdToSendInCheckout = null;
      this.third_party_string = "";
      this.time = null;
      this.businessTypeFromSlotRequest = null;
      this.timeSlotDetail_delivery_charges = 0;
      this.platformFeeData.delivery_charges =
        this.timeSlotDetail_delivery_charges;
      if (this.pickUpCheck == true) {
        this.charges = 0;
      } else {
        this.charges =
          this.platformFeeData.delivery_charges +
          this.platformFeeData.platform_fee;
      }
      this.discountFunction();
    }, 500);
  }

  closeOutletDetailBox() {
    console.log("close outlet called, array set to empty.");
    this.outletDisplayDataArray = [];
    this.outletSearchBox = true;
    this.showDistance();
  }

  // Customer add code
  findCustomer() {
    this.nao.go(30);
    var getCode = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
    var num = "+" + getCode + this.number;
    console.log("login data");
    this.dataService
      .showCustomerList(window.localStorage.getItem("token"), num)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.findCustomerData = data;
          if (this.findCustomerData.rest_error_code === 4) {
            // toastr.error('Customer does not exist');
            this.customerMatch = false;
            $("#datepicker").val("");
            this.first_name = "";
            this.last_name = "";
            this.accept_marketing = false;
            this.is_tax_exempt = false;
            this.email = "";
            this.note = "";
            this.findCustomerData = "";
            this.address_line1 = "";
            this.address_line2 = "";
            this.city = "";
            this.state = "";
            this.zip = "";
            this.area = "";
            $("#is_tax_exempt").prop("checked", false);
            $("#accept_marketing").prop("checked", false);
            this.selectAddress = false;
            return;
          } else {
            this.dob = "";
            this.selDate = "";
            setTimeout(() => {
              // this.findCustomerData = data;
              // $('#datepicker').val(this.findCustomerData.date_of_birth);
              this.dob = this.findCustomerData.date_of_birth;
              this.selDate = this.findCustomerData.date_of_birth;
              this.first_name = this.findCustomerData.first_name;
              this.last_name = this.findCustomerData.last_name;
              this.gender = this.findCustomerData.gender;
              this.accept_marketing = this.findCustomerData.accept_marketing;
              this.is_tax_exempt = this.findCustomerData.tax_exempt;
              this.email = this.findCustomerData.email;
              this.note = this.findCustomerData.note;
              this.findCustomerData = this.findCustomerData.address;
              this.latitude = this.findCustomerData.latitude;
              this.longitude = this.findCustomerData.longitude;
              this.address_line1 = this.findCustomerData.address_line1;
              this.address_line2 = this.findCustomerData.address_line2;
              this.city = this.findCustomerData.city;
              this.state = this.findCustomerData.state;
              this.street = this.findCustomerData.street;
              this.zip = this.findCustomerData.zip;
              this.area = this.findCustomerData.area;
              this.apart = this.findCustomerData.apart_no;
              if (this.is_tax_exempt === true) {
                $("#is_tax_exempt").prop("checked", true);
              }
              if (this.accept_marketing === true) {
                $("#accept_marketing").prop("checked", true);
              }
              this.customerMatch = true;
              console.log("cutomer data get with phone#", data);
              if (
                this.findCustomerData.longitude !== null &&
                this.findCustomerData.longitude !== "" &&
                this.findCustomerData.latitude !== null &&
                this.findCustomerData.latitude !== "" &&
                this.findCustomerData.address_line1 !== null &&
                this.findCustomerData.address_line1 !== ""
              ) {
                this.selectAddress = true;
                this.callMap();
              } else {
                this.selectAddress = false;
              }
            }, 1000);
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  prefindCustomerForDisplayData(number) {
    this.nao.go(30);
    console.log("showCustomerListById", number);
    this.dataService
      .showCustomerListById(window.localStorage.getItem("token"), number)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.prefilledCustomerData = data;
          this.customerDisplayDataArray = [];
          if (this.prefilledCustomerData.country_code === "+1") {
            this.prefilledCustomerData.phone_number = format(
              this.prefilledCustomerData.phone_number,
              "US",
              "NATIONAL"
            );
            console.log(
              "this.prefilledCustomerData.number",
              this.prefilledCustomerData.phone_number
            );
          }

          this.selectedCustomerId = this.prefilledCustomerData.id;
          this.selectedCustomerObj = this.prefilledCustomerData;
          this.customerAddressList =
            this.prefilledCustomerData.address_list.address_dictionary;
          this.customerDisplayDataArray.push({
            id: this.prefilledCustomerData.id,
            first_name: this.prefilledCustomerData.first_name,
            last_name: this.prefilledCustomerData.last_name,
            payments: this.prefilledCustomerData.payments,
            email: this.prefilledCustomerData.email,
            country_code: this.prefilledCustomerData.country_code,
            phone_number: this.prefilledCustomerData.phone_number,
            address: "",
            street: "",
            city: "",
            state: "",
            area: "",
            zip: "",
            apart_no: "",
            longitude: 0,
            latitude: 0,
            is_default: false,
            place_label: false,
            address_id: null,
          });
          for (
            var j = 0;
            j <
            this.prefilledCustomerData.address_list.address_dictionary.length;
            j++
          ) {
            if (
              this.prefilledCustomerData.address_list.address_dictionary[j]
                .is_default === true
            ) {
              this.customerDisplayDataArray = [];
              this.customerDisplayDataArray.push({
                id: this.prefilledCustomerData.id,
                first_name: this.prefilledCustomerData.first_name,
                last_name: this.prefilledCustomerData.last_name,
                payments: this.prefilledCustomerData.payments,
                email: this.prefilledCustomerData.email,
                country_code: this.prefilledCustomerData.country_code,
                phone_number: this.prefilledCustomerData.phone_number,
                address:
                  this.prefilledCustomerData.address_list.address_dictionary[j]
                    .address_line1,
                street:
                  this.prefilledCustomerData.address_list.address_dictionary[j]
                    .address_line1,
                city: this.prefilledCustomerData.address_list
                  .address_dictionary[j].city,
                state:
                  this.prefilledCustomerData.address_list.address_dictionary[j]
                    .state,
                area: this.prefilledCustomerData.address_list
                  .address_dictionary[j].country,
                zip: this.prefilledCustomerData.address_list.address_dictionary[
                  j
                ].zip,
                apart_no:
                  this.prefilledCustomerData.address_list.address_dictionary[j]
                    .apart_no,
                longitude:
                  this.selectedCustomerObj.address_list.address_dictionary[j]
                    .longitude,
                house_building_no:
                  this.prefilledCustomerData.address_list.address_dictionary[j]
                    .house_building_no,
                latitude:
                  this.selectedCustomerObj.address_list.address_dictionary[j]
                    .latitude,
                is_default:
                  this.prefilledCustomerData.address_list.address_dictionary[j]
                    .is_default,
                place_label:
                  this.prefilledCustomerData.address_list.address_dictionary[j]
                    .place_label,
                address_id:
                  this.prefilledCustomerData.address_list.address_dictionary[j]
                    .id,
              });
              this.showDistance();
            }
          }

          $(".CustomerSearchBoxHide").css("display", "block");
          $(".CustomerSearchBoxShow").css("display", "none");
          this.getPayementCard();
          if (this.productDisplayDataArray.length > 0) {
            this.getSlotsDataWithAddress();
          }
          $("#paymentNoCheck-cash").css("display", "none");
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  openAddCustomerPop() {
    $(".c-label input").css("border-color", "#ccc");
    if (this.searchStringCustomer.length == 11) {
      this.searchStringCustomer = this.searchStringCustomer.substr(1);
    }
    if (this.searchStringCustomer.length >= 13) {
      this.searchStringCustomer = this.searchStringCustomer.substr(3);
    }
    if (this.searchStringCustomer.length > 10) {
      this.numChk = true;
      $("#phoneValue").css("border-color", "#eb3b3b");
    }
    this.customerMatch = false;
    $("#datepicker").val("");
    this.first_name = "";
    this.last_name = "";
    this.accept_marketing = false;
    this.is_tax_exempt = false;
    this.email = "";
    this.note = "";
    this.findCustomerData = "";
    this.number = this.searchStringCustomer;
    this.address_line1 = "";
    this.address_line2 = "";
    this.city = "";
    this.state = "";
    this.street = "";
    this.zip = "";
    this.area = "";
    this.apart = "";
    // $('#city').val('');
    // $('#zip').val('');
    // $('#state').val('');
    // $('#area').val('');
    // $('#apart').val('');
    $("#is_tax_exempt").prop("checked", false);
    $("#accept_marketing").prop("checked", false);
    this.findCustomer();
    $("#addCustomerPop").modal("show");
    $(".c-label label").css("color", "#3d3e3d");
    $(".uploadText").css("color", "#3d3e3d");
    // $('.c-label input').css('border-color', '#ccc');
    $(".c-label textarea").css("border-color", "#ccc");
    this.selectAddress = false;
  }

  addCutomerFunction() {
    console.log(this.dispensary_id);
    this.error_count = 0;
    $(".c-label label").css("color", "#3d3e3d");
    $(".uploadText").css("color", "#3d3e3d");
    $(".c-label input").css("border-color", "#ccc");
    $(".c-label textarea").css("border-color", "#ccc");
    this.addingCustomer = true;
    if ($("#is_tax_exempt").is(":checked")) {
      this.is_tax_exempt = true;
    }
    if ($("#accept_marketing").is(":checked")) {
      this.accept_marketing = true;
    }
    this.address_line1 = $("#searchTextFieldAddAddress").val();
    this.city = $("#city").val();
    this.zip = $("#zip").val();
    this.houseNo = $("#houseNo").val();
    this.state = $("#state").val();
    this.area = $("#area").val();
    this.apart = $("#apart").val();
    // this.dob = $('#datepicker').val();
    var formatedDob = this.dob.formatted;
    this.address_line1 = $("#searchTextFieldAddAddress").val();
    console.log("login data", this.address_line1);
    if (this.first_name === "" || this.first_name === undefined) {
      $("#c-fname label").css("color", "#a10a0d");
      $("#c-fname input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.last_name === "" || this.last_name === undefined) {
      $("#c-lname label").css("color", "#a10a0d");
      $("#c-lname input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (
      this.number === "" ||
      this.number === undefined ||
      this.numChk === true
    ) {
      $("#c-phone label").css("color", "#a10a0d");
      $("#c-phone input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.gender === "" || this.gender === -1) {
      $("#c-gender label").css("color", "#a10a0d");
      $("#c-gender input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    // if (this.dob === '' || this.dob === undefined) {
    //             $('#c-dob label').css('color', '#a10a0d');
    //             $('#c-dob input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // if (!this.emailChk.test(this.email) && this.email !== '') {
    //             $('#c-email label').css('color', '#a10a0d');
    //             $('#c-email input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (this.address_line1 === "" || this.address_line1 === undefined) {
      $("#c-address label").css("color", "#a10a0d");
      $("#c-address input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    // if (this.address_line2 === '' || this.address_line2 === undefined) {
    //             $('#c-address2 label').css('color', '#a10a0d');
    //             $('#c-address2 input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (this.city === "" || this.city === undefined) {
      $("#c-city label").css("color", "#a10a0d");
      $("#c-city input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.zip === "" || this.zip === undefined) {
      $("#c-zip label").css("color", "#a10a0d");
      $("#c-zip input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    // if (this.state === '' || this.state === undefined) {
    //   $('#c-state label').css('color', '#a10a0d');
    //   $('#c-state input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.area === '' || this.area === undefined) {
    //   $('#c-area label').css('color', '#a10a0d');
    //   $('#c-area input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.note === '' || this.note === undefined) {
    //             $('#c-note label').css('color', '#a10a0d');
    //             $('#c-note input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (this.error_count > 0) {
      return;
    }
    if (
      this.latitude === undefined ||
      this.latitude === "" ||
      this.longitude === undefined ||
      this.longitude === ""
    ) {
      toastr.error(
        "Please Update the address & select it from Google suggestions for accuracy"
      );
      return;
    }
    var getCode = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
    var number = "+" + getCode + this.number;
    console.log("number", this.number);
    this.nao.go(30);
    this.btnDisable = true;
    this.street = this.address_line1;
    this.dataService
      .addCustomer(
        window.localStorage.getItem("token"),
        this.first_name,
        this.last_name,
        number,
        this.email,
        (this.is_tax_exempt = false),
        (this.accept_marketing = false),
        this.address_line1,
        this.street,
        this.address_line2,
        this.city,
        this.state,
        this.zip,
        this.area,
        this.apart,
        this.note,
        formatedDob,
        this.latitude,
        this.longitude,
        this.houseNo,
        this.gender,
        this.dispensary_id
      )
      .subscribe(
        (data) => {
          console.log("outlet data");
          this.nao.go(100);
          this.success = data;
          this.restErrorCode = data;
          this.restErrorCode = this.restErrorCode.rest_error_code;
          // this.success = this.success.success;
          if (this.restErrorCode === 1) {
            toastr.error("Some thing went wrong");
            this.btnDisable = false;
          }
          if (this.restErrorCode === 2) {
            toastr.error("Please login again");
            this.btnDisable = false;
          }
          if (this.restErrorCode === 3) {
            toastr.error("Customer already exists");
            this.btnDisable = false;
          }
          if (this.restErrorCode === 4) {
            toastr.error("Customer does not exist");
            this.btnDisable = false;
          }
          if (this.success.success === true) {
            this.btnDisable = false;
            $("#addCustomerPop").modal("hide");
            // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
            // var number = '+' + getCode + this.number;
            var numberid = this.success.customer_id;
            console.log("in success of add customer", numberid, this.success);
            this.prefindCustomerForDisplayData(numberid);
            // this.searchStringCustomer = this.first_name;
            // $('#cText').focus();
            // this.searchCustomerOnOrder();
          }
          if (this.success.success === false) {
            this.addingCustomer = false;
            this.btnDisable = false;
          }
        },
        (error) => {
          this.nao.go(100);
          this.addingCustomer = false;
          this.btnDisable = false;
          console.log("error", error);
        }
      );
  }

  addressDetailAddCustomer() {
    this.street = "";
    console.log("chk address detail", this.place);
    for (var i = 0; i < this.placeDetailData.length; i++) {
      for (var j = 0; j < this.placeDetailData[i].types.length; j++) {
        if (
          this.placeDetailData[i].types[j] === "administrative_area_level_2"
        ) {
          $("#city").val(this.placeDetailData[i].long_name);
        } else if (this.placeDetailData[i].types[j] === "locality") {
          // this.city = this.placeDetailData[i].long_name;
          // console.log('city', this.city);
          $("#city").val(this.placeDetailData[i].long_name);
        }
        if (this.placeDetailData[i].types[j] === "street_number") {
          this.street = this.placeDetailData[i].long_name;
          console.log("street number", this.street);
        }
        if (this.placeDetailData[i].types[j] === "route") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("route", this.street);
        }
        if (this.placeDetailData[i].types[j] === "sublocality_level_2") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("sublocality 2", this.street);
        }
        if (this.placeDetailData[i].types[j] === "sublocality_level_1") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("sublocality 1", this.street);
        }

        if (
          this.placeDetailData[i].types[j] === "administrative_area_level_1"
        ) {
          // this.state = this.placeDetailData[i].long_name;
          $("#state").val(this.placeDetailData[i].short_name);
        }

        if (this.placeDetailData[i].types[j] === "country") {
          // this.area = this.placeDetailData[i].long_name;
          $("#area").val(this.placeDetailData[i].long_name);
        }

        if (this.placeDetailData[i].types[j] === "postal_code") {
          // this.zip = this.placeDetailData[i].long_name;
          console.log("postal; code", this.placeDetailData[i].long_name);
          $("#zip").val(this.placeDetailData[i].long_name);
        } else {
          $("#zip").val("");
        }
        // this.latitude = this.place.geometry.location.lat();
        // this.longitude = this.place.geometry.location.lng();
      }
    }
  }

  // inputAddress2() {
  // const input2 = document.getElementById('searchTextField2');
  // const searchBox2 = new google.maps.places.Autocomplete(input2);
  // searchBox2.addListener('place_changed', function() {
  //
  //   console.log('place changed');
  //   // const place = searchBox2.getPlace();
  //   // console.log('address', place);
  // });
  // }

  addressDetailEdit() {
    var context = this;
    $("#state2").val("");
    // const input3 = document.getElementById('findPlaceOnOrder');
    // const searchBox3 = new google.maps.places.Autocomplete(input3);
    // searchBox3.addListener('place_changed', function() {

    // console.log('place changed');
    //   context.placeForEditAddress = searchBox3.getPlace();
    console.log("address", context.placeForEditAddress);
    for (var i = 0; i < context.placeDetailData2.length; i++) {
      for (var j = 0; j < context.placeDetailData2[i].types.length; j++) {
        if (
          context.placeDetailData2[i].types[j] === "administrative_area_level_2"
        ) {
          $("#city2").val(context.placeDetailData2[i].long_name);
        } else if (context.placeDetailData2[i].types[j] === "locality") {
          // this.city = this.placeDetailData[i].long_name;
          // console.log('city', this.city);
          $("#city2").val(context.placeDetailData2[i].long_name);
        }

        if (context.placeDetailData2[i].types[j] === "street_number") {
          context.street3 = context.placeDetailData2[i].long_name;
          console.log("street number", context.street3);
        }
        if (context.placeDetailData2[i].types[j] === "route") {
          context.street3 =
            context.street3 + " " + context.placeDetailData2[i].long_name;
          console.log("route", context.street3);
        }
        if (context.placeDetailData2[i].types[j] === "sublocality_level_2") {
          context.street3 =
            context.street3 + " " + context.placeDetailData2[i].long_name;
          console.log("sublocality 2", this.street);
        }
        if (context.placeDetailData2[i].types[j] === "sublocality_level_1") {
          context.street3 =
            context.street3 + " " + context.placeDetailData2[i].long_name;
          console.log("sublocality 1", context.street3);
        }

        if (
          context.placeDetailData2[i].types[j] === "administrative_area_level_1"
        ) {
          // this.state = this.placeDetailData[i].long_name;
          $("#state2").val(context.placeDetailData2[i].short_name);
        }

        if (context.placeDetailData2[i].types[j] === "country") {
          // this.area = this.placeDetailData[i].long_name;
          $("#area2").val(context.placeDetailData2[i].long_name);
        }

        if (context.placeDetailData2[i].types[j] === "postal_code") {
          // this.zip = this.placeDetailData[i].long_name;
          console.log("postal; code", context.placeDetailData2[i].long_name);
          $("#zip2").val(context.placeDetailData2[i].long_name);
        } else {
          $("#zip2").val("");
        }
        // context.latitude2 = context.placeForEditAddress.geometry.location.lat();
        // context.longitude2 = context.placeForEditAddress.geometry.location.lng();
      }
    }
    // });
  }

  // inputAddress1() {
  //   console.log('inputAddress');
  //   var context = this;
  //   const input = document.getElementById('searchTextField');
  //
  //   const searchBox = new google.maps.places.Autocomplete(input);
  //   searchBox.addListener('place_changed', function() {
  //
  //     console.log('place changed');
  //     context.place = searchBox.getPlace();
  //     console.log('address', context.place);
  //     context.addressDetailOrder();
  //   });
  // }

  functionTogetPlace() {
    if (this.selectAddress === true) {
      return;
    }
    this.placeDataFound = false;
    this.placeSuggestionsData = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // this.addressLoad = true;
      this.dataService.googleAddress(this.address_line1).subscribe(
        (data) => {
          this.placeSuggestionsData = data;
          this.placeSuggestionsData = this.placeSuggestionsData.predictions;
          // console.log('place google data', this.placeSuggestionsData);
          this.placeDataFound = true;
          if ($(".myDrop").hasClass("open")) {
          } else {
            $(".myDrop").addClass("open");
          }
          // this.addressLoad = false;
          // $('#searchTextField').click();
          // $('#searchTextField').focus();
        },
        (_error) => {}
      );
    }, 1000);
  }

  functionTogetPlaceDetail(name, id) {
    this.addressLoad = true;
    this.address_line1 = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.dataService.googleAddressDetail(id).subscribe(
        (data) => {
          // console.log('place google detail data', data);
          this.placeDetailData = data;
          this.selectAddress = true;
          this.placeDetailData = this.placeDetailData.result;
          this.latitude = this.placeDetailData.geometry.location.lat;
          this.longitude = this.placeDetailData.geometry.location.lng;
          // console.log('this.latitude', this.latitude);
          // console.log('this.longitude', this.longitude);
          this.placeDetailData = this.placeDetailData.address_components;
          setTimeout(() => {
            this.callMap();
            this.addressDetailAddCustomer();
            this.addressLoad = false;
          }, 1000);
        },
        (_error) => {}
      );
    }, 1000);
  }

  resetAddress() {
    this.address_line1 = "";
    // this.address_line2 = '';
    this.city = "";
    this.state = "";
    this.zip = "";
    this.area = "";
    this.houseNo = "";
    this.apart = "";
    this.longitude = "";
    this.latitude = "";
    this.selectAddress = false;
  }

  callMap() {
    setTimeout(() => {
      $("#myMapDiv").css("display", "block");
      var context = this;
      var map;
      var marker;
      var adr;
      var myLatlng = new google.maps.LatLng(this.latitude, this.longitude);
      var geocoder = new google.maps.Geocoder();
      var infowindow = new google.maps.InfoWindow();
      var mapOptions = {
        zoom: 20,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        navigationControl: false,
        // mapTypeControl: false,
        // disableDefaultUI: true
      };
      var endImage = {
        url: "assets/pin.png", // url
        scaledSize: new google.maps.Size(20, 32), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(10, 35), // anchor
      };
      map = new google.maps.Map(document.getElementById("myMap"), mapOptions);
      marker = new google.maps.Marker({
        map: map,
        position: myLatlng,
        draggable: true,
        icon: endImage,
      });
      geocoder.geocode({ latLng: myLatlng }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            // $('#address').val(results[0].formatted_address);
            // $('#latitude').val(marker.getPosition().lat());
            // $('#longitude').val(marker.getPosition().lng());
            infowindow.setContent(results[0].formatted_address);
            infowindow.open(map, marker);
            context.latitude = marker.getPosition().lat();
            context.longitude = marker.getPosition().lng();
            console.log(context.latitude, context.longitude);
            console.log("results", results);
            // context.getDeliveryAddressDetail(results[0]);
          }
        }
      });

      google.maps.event.addListener(marker, "dragend", function () {
        geocoder.geocode(
          { latLng: marker.getPosition() },
          function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              if (results[0]) {
                infowindow.setContent(results[0].formatted_address);
                infowindow.open(map, marker);
                context.latitude = marker.getPosition().lat();
                context.longitude = marker.getPosition().lng();
                // context.addressNew =  results[0].formatted_address;
                console.log(context.latitude, context.longitude);
                console.log("results", results);
                // this.changeRef.detectChanges();
                // context.getDeliveryAddressDetail(results[0]);
              }
            }
          }
        );
      });
    }, 10);
  }

  // for edit address
  functionTogetPlace2() {
    if (this.selectAddressCustomer === true) {
      return;
    }
    this.placeDataFound2 = false;
    this.placeSuggestionsData2 = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // this.addressLoad = true;
      this.dataService.googleAddress(this.address).subscribe(
        (data) => {
          this.placeSuggestionsData2 = data;
          this.placeSuggestionsData2 = this.placeSuggestionsData2.predictions;
          // console.log('place google data', this.placeSuggestionsData);
          this.placeDataFound2 = true;
          if ($(".myDrop").hasClass("open")) {
          } else {
            $(".myDrop").addClass("open");
          }
          // this.addressLoad = false;
          // $('#searchTextField').click();
          // $('#searchTextField').focus();
        },
        (_error) => {}
      );
    }, 1000);
  }

  functionTogetPlaceDetail2(name, id) {
    this.addressLoad2 = true;
    // this.address_line1 = name;
    this.address = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.dataService.googleAddressDetail(id).subscribe(
        (data) => {
          // console.log('place google detail data', data);
          this.placeDetailData2 = data;
          this.selectAddressCustomer = true;
          $(".selectAddressCustomerEdit").css("display", "block");
          this.placeDetailData2 = this.placeDetailData2.result;
          this.latitude2 = this.placeDetailData2.geometry.location.lat;
          this.longitude2 = this.placeDetailData2.geometry.location.lng;
          // console.log('this.latitude', this.latitude);
          // console.log('this.longitude', this.longitude);
          this.placeDetailData2 = this.placeDetailData2.address_components;
          this.callMapCustomer();
          setTimeout(() => {
            this.addressDetailEdit();
            this.addressLoad2 = false;
          }, 1000);
        },
        (_error) => {}
      );
    }, 1000);
  }

  restrictUserInput($event) {
    $event.preventDefault();
  }

  editAddressFunnc(address) {
    if (this.customerDisplayDataArray[0].is_default === false) {
      this.selectAddressCustomerFun(address);
      return;
    }
    console.log("customerDisplayDataArray", this.customerDisplayDataArray);
    this.selectAddressCustomer = true;
    // this.editAddress = true;
    $(".editAddressHide").css("display", "block");
    $(".editAddressShow").css("display", "none");
    $(".selectAddressCustomerEdit").css("display", "block");
    $("#findPlaceOnOrder").val("");
    this.placeLabelDefault = address.place_label;
    $("#city2").val(address.city);
    $("#state2").val(address.state);
    $("#area2").val(address.country);
    $("#zip2").val(address.zip);
    $("#editHouseNo").val(address.house_building_no);
    $("#apart_no").val(address.apart_no);
    $("#findPlaceOnOrder").val(address.address_line1);
    // $('#findPlaceOnOrder').val(this.customerDisplayDataArray[0].street);
    console.log("street", address.street);
    this.placeSuggestionsData2 = [];
    // this.address = this.customerDisplayDataArray[0].street;
    this.street3 = "";
    this.editAddressId = address.id;

    this.longitude2 = address.longitude;
    this.latitude2 = address.latitude;
    this.callMapCustomer();
  }

  editAddressFunncClose() {
    // this.editAddress = false;
    $(".editAddressHide").css("display", "none");
    $(".editAddressShow").css("display", "block");
  }

  editAddressDone() {
    console.log("val chk", this.latitude2, this.longitude2);
    if (
      $("#findPlaceOnOrder").val() === "" ||
      $("#city2").val() === "" ||
      $("#zip2").val() === ""
    ) {
      toastr.error("Please fill all address fields");
      return;
    }

    this.customerDisplayDataArray[0].address = $("#findPlaceOnOrder").val();
    this.customerDisplayDataArray[0].city = $("#city2").val();
    this.customerDisplayDataArray[0].state = $("#state2").val();
    this.customerDisplayDataArray[0].house_building_no =
      $("#editHouseNo").val();
    this.customerDisplayDataArray[0].area = $("#area2").val();
    this.customerDisplayDataArray[0].zip = $("#zip2").val();
    this.customerDisplayDataArray[0].apart_no = $("#apart_no").val();
    // this.customerDisplayDataArray[0].street = this.street3;
    this.customerDisplayDataArray[0].street = $("#findPlaceOnOrder").val();
    this.customerDisplayDataArray[0].longitude = this.longitude2;
    this.customerDisplayDataArray[0].latitude = this.latitude2;
    this.customerDisplayDataArray[0].place_label = this.placeLabelDefault;

    this.showDistance();

    this.dataService
      .editCustomerAddresss(
        window.localStorage.getItem("token"),
        this.customerDisplayDataArray[0].address,
        this.customerDisplayDataArray[0].street,
        this.customerDisplayDataArray[0].city,
        this.customerDisplayDataArray[0].state,
        this.customerDisplayDataArray[0].zip,
        this.customerDisplayDataArray[0].area,
        this.customerDisplayDataArray[0].apart_no,
        this.customerDisplayDataArray[0].id,
        this.customerDisplayDataArray[0].latitude,
        this.customerDisplayDataArray[0].longitude,
        this.customerDisplayDataArray[0].place_label,
        this.editAddressId,
        this.customerDisplayDataArray[0].house_building_no
      )
      .subscribe(
        (_data) => {
          var number = this.selectedCustomerObj.id;
          // var number =  this.selectedCustomerObj.country_code + this.selectedCustomerObj.phone_number;
          // number = number.replace('(', '');
          // number = number.replace(')', '');
          // number = number.replace('-', '');
          // number = number.replace(/\s/g, '');
          this.prefindCustomerForDisplayData(number);
          $(".editAddressHide").css("display", "none");
          $(".editAddressShow").css("display", "block");
        },
        (error) => {
          console.log("error", error);
        }
      );
  }

  showDistance() {
    this.final_answer = this.getDistance();
    this.final_answer = this.final_answer / 1000;
    console.log(this.final_answer);
  }

  rad(x) {
    return (x * Math.PI) / 180;
  }

  getDistance() {
    let latitude;
    let longitutde;
    let secondLat;
    let secondLong;
    if (this.outletDisplayDataArray.length > 0) {
      latitude = this.outletDisplayDataArray[0].latitude;
      longitutde = this.outletDisplayDataArray[0].longitude;
    } else {
      latitude = this.outletData[0].latitude;
      longitutde = this.outletData[0].longitude;
    }
    if (this.customerDisplayDataArray.length > 0) {
      secondLat = this.customerDisplayDataArray[0].latitude;
      secondLong = this.customerDisplayDataArray[0].longitude;
    }
    var R = 6378137; // Earth’s mean radius in meter
    var dLat = this.rad(secondLat - latitude);
    var dLong = this.rad(secondLong - longitutde);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.rad(secondLat)) *
        Math.cos(this.rad(latitude)) *
        Math.sin(dLong / 2) *
        Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d; // returns the distance in meter
  }

  callMapCustomer() {
    var context = this;
    var map;
    var marker;
    var adr;
    var myLatlng = new google.maps.LatLng(this.latitude2, this.longitude2);
    var geocoder = new google.maps.Geocoder();
    var infowindow = new google.maps.InfoWindow();
    var mapOptions = {
      zoom: 18,
      center: myLatlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      navigationControl: false,
      // mapTypeControl: false,
      // disableDefaultUI: true
    };
    var endImage = {
      url: "assets/pin.png", // url
      scaledSize: new google.maps.Size(30, 42), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 41), // anchor
    };
    map = new google.maps.Map(
      document.getElementById("customerMap"),
      mapOptions
    );
    marker = new google.maps.Marker({
      map: map,
      position: myLatlng,
      draggable: true,
      icon: endImage,
    });
    geocoder.geocode({ latLng: myLatlng }, function (results, status) {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          infowindow.setContent(results[0].formatted_address);
          infowindow.open(map, marker);
          context.latitude2 = marker.getPosition().lat();
          context.longitude2 = marker.getPosition().lng();
          console.log(context.latitude2, context.longitude2);
          console.log("results", results);
        }
      }
    });

    google.maps.event.addListener(marker, "dragend", function () {
      geocoder.geocode(
        { latLng: marker.getPosition() },
        function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              infowindow.setContent(results[0].formatted_address);
              infowindow.open(map, marker);
              context.latitude2 = marker.getPosition().lat();
              context.longitude2 = marker.getPosition().lng();
              console.log(context.latitude2, context.longitude2);
              console.log("results", results);
            }
          }
        }
      );
    });
  }

  resetAddressCustomer() {
    $("#findPlaceOnOrder").val("");
    $("#city2").val("");
    $("#state2").val("");
    $("#editHouseNo").val("");
    this.editHouseNo = "";
    $("#area2").val("");
    $("#zip2").val("");
    $("#apart_no").val("");
    $(".selectAddressCustomerEdit").css("display", "none");
    this.selectAddressCustomer = false;
  }

  countryValidation() {
    var code = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
    code = "+" + code;
    var val = $("#phoneValue").val();
    for (var i = 0; i < this.cs.country.length; i++) {
      if (code === this.cs.country[i].countryCode) {
        console.log("val.length", val.length, this.cs.country[i].length);
        if (val.length === this.cs.country[i].length) {
          console.log("valid");
          this.numChk = false;
          $("#phoneValue").css("border-color", "#ccc");
        } else {
          console.log("invalid");
          this.numChk = true;
          $("#phoneValue").css("border-color", "#eb3b3b");
        }
      }
    }
  }

  prevent($event) {
    // console.log('prevent default', $event.keyCode);
    if ($event.keyCode === 8 || $event.keyCode === 46) {
      return;
    }
    if (!($event.keyCode >= 48 && $event.keyCode <= 57)) {
      $event.preventDefault();
      return;
    }
  }

  preventMaxVal($event) {
    // var a = $('#discount').val();
    this.discount = parseInt(this.discount);
    console.log("a", this.discount);
    if (this.discount >= 10) {
      // this.discount = 100;
      console.log("value great", this.discount);
      $event.preventDefault();
      // return;
    }
  }

  getPlatformFeeFunction() {
    // this.nao.go(30);
    this.dataService
      .getPlatformChargesForFee(
        window.localStorage.getItem("token"),
        this.dispensary_id
      )
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.platformFeeData = data;
          this.platformFeeData = this.platformFeeData.charges;
          // this.totalPrice  = this.platformFeeData.total_charges;
          this.tax_charges = Math.round(this.platformFeeData.tax_rate);
          this.platformFeeData.delivery_charges = Math.round(
            this.timeSlotDetail_delivery_charges
          );
          if (this.pickUpCheck == true) {
            this.charges = 0;
          } else {
            this.charges =
              this.platformFeeData.delivery_charges +
              this.platformFeeData.platform_fee;
          }
          this.charges = Math.round(this.charges);
          this.totalPrice = this.charges;
          // this.tax_chargesToDisplay = this.platformFeeData.tax_rate;
          // this.platform_charges = this.platformFeeData.delivery_charges;
        },
        (_error) => {
          // this.nao.go(100);
        }
      );
  }

  getBusinessProfile() {
    console.log("showPaymentViewfirst", this.showPaymentView);
    this.dataService
      .businessProfile(window.localStorage.getItem("token"), this.dispensary_id)
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.businessProfileData = data;
          if (this.businessProfileData.payment_through_cash === true) {
            this.paymentThroughCash = "true";
          } else {
            this.paymentThroughCash = "false";
          }
          if (this.businessProfileData.payment_through_card === true) {
            this.paymentThroughCard = "true";
          } else {
            this.paymentThroughCard = "false";
          }
          if (this.businessProfileData.payment_through_bank_transfer === true) {
            this.paymentThroughBankTransfer = "true";
          } else {
            this.paymentThroughBankTransfer = "false";
          }
          if (this.businessProfileData.payment_through_mpos === true) {
            this.paymentThroughMpos = "true";
          } else {
            this.paymentThroughMpos = "false";
          }

          setTimeout(() => {
            // if (this.paymentThroughCash === 'true' && this.paymentThroughCard === 'true') {
            //   this.paymentMethodOptionValue = -1;
            // }
            // if (this.paymentThroughCash === 'true' && this.paymentThroughCard === 'false') {
            //   $('#paymentNoCheck-1').css('display', 'inline');
            //   this.paymentMethodOptionValue = 0;
            // }
            // console.log(this.paymentThroughCash, this.paymentThroughCard);
            // if (this.paymentThroughCash === 'false' && this.paymentThroughCard === 'true') {
            //   this.paymentMethodOptionValue = 1;
            //   for (let i = 0; i < this.paymentCardData.length; i++) {
            //     if (this.paymentCardData[i].primary === true) {
            //       $('#paymentNoCheck' + i).css('display', 'inline');
            //     }
            //   }
            //   if (this.paymentCardData.length === 0) {
            //     this.paymentMethodOptionValue = -1;
            //   }
            // }
            if (
              this.paymentThroughCash === "true" &&
              this.paymentThroughCard === "true" &&
              this.paymentThroughBankTransfer === "true" &&
              this.paymentThroughMpos === "true"
            ) {
              this.paymentMethodOptionValue = -1;
            }
            if (
              this.paymentThroughCash === "true" &&
              this.paymentThroughCard === "false" &&
              this.paymentThroughBankTransfer === "false" &&
              this.paymentThroughMpos === "false"
            ) {
              $("#paymentNoCheck-1").css("display", "inline");
              this.paymentMethodOptionValue = 0;
              this.cash_check = true;
            }
            console.log(this.paymentThroughCash, this.paymentThroughCard);
            if (
              this.paymentThroughCash === "false" &&
              this.paymentThroughCard === "true" &&
              this.paymentThroughBankTransfer === "false" &&
              this.paymentThroughMpos === "false"
            ) {
              this.paymentMethodOptionValue = 1;
              this.card_check = true;
              for (let i = 0; i < this.paymentCardData.length; i++) {
                if (this.paymentCardData[i].primary === true) {
                  $("#paymentNoCheck" + i).css("display", "inline");
                }
              }
              if (this.paymentCardData.length === 0) {
                this.paymentMethodOptionValue = -1;
              }
            }
            if (
              this.paymentThroughCash === "false" &&
              this.paymentThroughCard === "false" &&
              this.paymentThroughBankTransfer === "true" &&
              this.paymentThroughMpos === "false"
            ) {
              this.paymentMethodOptionValue = 2;
              this.card_check = true;
            }
            if (
              this.paymentThroughCash === "false" &&
              this.paymentThroughCard === "false" &&
              this.paymentThroughBankTransfer === "false" &&
              this.paymentThroughMpos === "true"
            ) {
              this.paymentMethodOptionValue = 3;
              this.card_check = true;
            }
          }, 2000);

          // this.paymentThroughCash = 'false';
          // this.paymentThroughCard = 'false';
          // this.paymentThroughCash = window.localStorage.getItem('paymentThroughCash');
          // this.paymentThroughCard = window.localStorage.getItem('paymentThroughCard');
        },
        (_error) => {
          // this.nao.go(100);
        }
      );
  }

  openSetLabelPopup() {
    this.placeLabelError = "";
    this.CustomeplaceLabel = "";
    if (
      this.placeLabelDefault === "Work" ||
      this.placeLabelDefault === "Home"
    ) {
      this.placeLabel = this.placeLabelDefault;
    } else {
      this.CustomeplaceLabel = this.placeLabelDefault;
    }
    $("#labelPopup").modal("show");
  }

  setLabel(label) {
    if (label === "Home") {
      this.placeLabel = "Home";
    }
    if (label === "Work") {
      this.placeLabel = "Work";
    }
    this.placeLabelError = "";
    this.CustomeplaceLabel = "";
  }

  customeLabelDone() {
    if (
      this.CustomeplaceLabel === "Work" ||
      this.CustomeplaceLabel === "Home"
    ) {
      return;
    }
    this.placeLabelDefault = this.placeLabel;
    $("#labelPopup").modal("hide");
  }

  changeSetLabel(value) {
    this.placeLabelError = "";
    if (value === "Work") {
      // this.CustomeplaceLabel = '';
      this.placeLabel = "";
      this.placeLabelError = "Please select Work from above";
      return;
    }
    if (value === "Home") {
      // this.CustomeplaceLabel = '';
      this.placeLabel = "";
      this.placeLabelError = "Please select Home from above";
      return;
    }
    if (value === "") {
      this.CustomeplaceLabel = "";
      this.placeLabel = "Home";
      return;
    }
    if (value !== "Home" && value !== "Work") {
      this.placeLabel = value;
      return;
    }
  }

  capitlizeAddressLabel() {
    this.CustomeplaceLabel = this.CustomeplaceLabel.replace(
      /\b\w/g,
      function (l) {
        return l.toUpperCase();
      }
    );
  }

  addNewAddressCustomer(customerId) {
    this.events.publish("AddAddressCustomerId", customerId);
    $(".AddNewAddressCustomerMain").css("display", "block");
    $(".createOrderPageMain").css("display", "none");
  }

  getSlotsDataWithAddress() {
    console.log("customerDisplayDataArray slot", this.customerDisplayDataArray);

    if (this.productDisplayDataArray.length === 0) {
      return;
    }
    if (this.pickUpCheck == false) {
      if (this.customerDisplayDataArray.length === 0) {
        return;
      }
      if (
        this.customerDisplayDataArray[0].latitude === 0 &&
        this.customerDisplayDataArray[0].longitude === 0
      ) {
        return;
      }
    }
    console.log("in customer address chek", this.customerDisplayDataArray);
    this.slotSuccessMessage = "";
    this.timeSlotDetail_delivery = [];
    var emptyArray = [];

    this.timeSlotDetail_delivery_show = JSON.parse(JSON.stringify(emptyArray));
    this.dayOfGivenTime = "";
    this.overnight = "";
    this.timeSlotDetail = null;
    this.dayIndex = null;
    this.outletIdToSendInCheckout = null;
    this.third_party_string = "";
    this.time = null;
    var productListForSlot = new Array();
    for (var i = 0; i < this.productDisplayDataArray.length; i++) {
      var obj = {
        product_id: this.productDisplayDataArray[i].id,
        variant_id: this.productDisplayDataArray[i].variant_id,
        quantity: this.productDisplayDataArray[i].quantityTotal,
      };
      productListForSlot.push(obj);
    }
    for (var j = 0; j < this.productDisplayDataArray.length; j++) {
      this.productDisplayDataArray[j].error_msg = "";
    }
    // this.delivery_man_type = 0;
    // this.isNation = false;
    // this.isLocal = false;

    var dayForTime = new Date();
    var currentSystemTime = new Date(dayForTime).toISOString();
    this.breakdownCharges = 0;
    this.breakdownChargesDis = 0;
    this.breakdownChargesTotal = 0;
    this.showBreakdownIcon = false;

    var todayData = this.todayData;
    if (this.todayData === 0) {
      todayData = 7;
    }
    this.dispensary_id;
    if (this.pickUpCheck == true) {
      // this.customerDisplayDataArray[0] = this.outletAddress;
    } else {
      // this.customerDisplayDataArray[0] = this.customerDisplayDataArray[0];
    }
    this.dataService
      .getSlotsListWithAddress(
        window.localStorage.getItem("token"),
        todayData,
        this.customerDisplayDataArray[0],
        productListForSlot,
        currentSystemTime,
        this.customerDisplayDataArray[0].id,
        this.subTotal,
        this.dispensary_id
      )
      .subscribe(
        (data) => {
          $("#slotDefault").prop("checked", false);
          $("#slotCustom").prop("checked", false);
          this.createorderResponseUpdate = data;
          this.slotSuccess = this.createorderResponseUpdate;
          if (this.slotSuccess.success === false) {
            if (
              this.slotSuccess.message ===
                "We cannot deliver in your area yet" ||
              this.slotSuccess.message === "We can not deliver in your area yet"
            ) {
              this.slotSuccessMessage = this.slotSuccess.message_with_business;
              toastr.error(this.slotSuccessMessage);
              this.businessTypeFromSlotRequest = null;
              this.outletSearchBox = true;
              return;
            }
          }
          this.createorderResponse = data;
          this.createorderResponse = this.createorderResponse.product;
          this.createorderResponseUpdate =
            this.createorderResponseUpdate.order_update_required;
          console.log(
            "this.createorderResponseUpdate",
            this.createorderResponseUpdate
          );
          if (this.createorderResponseUpdate === true) {
            for (var i = 0; i < this.createorderResponse.length; i++) {
              if (
                this.createorderResponse[i].variant_id ===
                this.productDisplayDataArray[i].variant_id
              ) {
                if (this.createorderResponse[i].out_of_stock === true) {
                  if (this.createorderResponse[i].available_quantity > 0) {
                    this.productDisplayDataArray[i].error_msg =
                      "*available quantity" +
                      " " +
                      this.createorderResponse[i].available_quantity;
                    this.btnDisableOrder = false;
                  } else {
                    this.productDisplayDataArray[i].error_msg = "Out of stock";
                    this.btnDisableOrder = false;
                  }
                  console.log(
                    "updateError",
                    this.productDisplayDataArray[i].error_msg
                  );
                } else {
                  this.productDisplayDataArray[i].error_msg = "";
                }
              }
            }
          }

          emptyArray = [];
          this.timeSlotDetail_delivery_show = JSON.parse(
            JSON.stringify(emptyArray)
          );
          this.timeSlotDetail = data;
          this.timeSlotDetailOrignal = data;
          this.outletIdToSendInCheckout = this.timeSlotDetail.outlet_id;
          this.timeSlotDetail = this.timeSlotDetail.detail_dictionary;
          this.timeSlotDetailOrignal =
            this.timeSlotDetailOrignal.detail_dictionary;
          this.over_night_charges = Math.round(
            this.timeSlotDetail.over_night_charges
          );
          this.days_charges = Math.round(this.timeSlotDetail.days_charges);
          this.timeSlotDetail_delivery = this.timeSlotDetail.delivery_slot_list;
          this.businessTypeFromSlotRequest = this.timeSlotDetail.business_type;
          this.timeSlotDetail_delivery_charges = Math.round(
            this.timeSlotDetail.delivery_rate_charges
          );
          this.timeSlotDetail_delivery_charges_actual = Math.round(
            this.timeSlotDetail.delivery_rate_charges_calculated
          );
          this.business_type = this.timeSlotDetail.business_type;
          console.log("timeSlotDetail_delivery", this.timeSlotDetail_delivery);
          var slotsArray = this.timeSlotDetail_delivery;
          for (var i = 0; i < slotsArray.length; i++) {
            if (slotsArray[i].slots.length > 0) {
              this.timeSlotDetail_delivery_show.push(slotsArray[i]);
            }
          }
          for (var i = 0; i < this.timeSlotDetail_delivery_show.length; i++) {
            for (
              var j = 0;
              j < this.timeSlotDetail_delivery_show[i].slots.length;
              j++
            ) {
              var cDate = new Date().getDate();
              var cYear = new Date().getFullYear();
              var cMonth = new Date().getUTCMonth() + 1;
              var openTime =
                this.timeSlotDetail_delivery_show[i].slots[j].open_time;
              var tOpen =
                cYear +
                "/" +
                cMonth +
                "/" +
                cDate +
                " " +
                openTime +
                " " +
                "UTC";
              var dateObjOpen = new Date(tOpen);
              this.timeSlotDetail_delivery_show[i].slots[j].open_time =
                dateObjOpen;

              var closeTime =
                this.timeSlotDetail_delivery_show[i].slots[j].close_time;
              var tClose =
                cYear +
                "/" +
                cMonth +
                "/" +
                cDate +
                " " +
                closeTime +
                " " +
                "UTC";
              var dateObjClose = new Date(tClose);
              this.timeSlotDetail_delivery_show[i].slots[j].close_time =
                dateObjClose;
            }
          }
          if (this.businessTypeFromSlotRequest === 1) {
            this.showBreakdownIcon =
              this.timeSlotDetailOrignal.off_price_subscribed_checked;
            this.breakdownCharges =
              this.timeSlotDetail.delivery_rate_charges_calculated;
            this.breakdownChargesDis = this.timeSlotDetail.off_price_subscribed;
            this.breakdownChargesTotal =
              this.timeSlotDetailOrignal.delivery_rate_charges;

            this.platformFeeData.delivery_charges =
              this.timeSlotDetail_delivery_charges;
            if (this.pickUpCheck == true) {
              this.charges = 0;
            } else {
              this.charges =
                this.platformFeeData.delivery_charges +
                this.platformFeeData.platform_fee;
            }
            this.discountFunction();
          }

          if (this.businessTypeFromSlotRequest === 0) {
            this.breakdownChargesDis = this.timeSlotDetail.off_price_subscribed;
            this.timeSlotDetail_delivery_charges = 0;
            this.platformFeeData.delivery_charges =
              this.timeSlotDetail_delivery_charges;
            if (this.pickUpCheck == true) {
              this.charges = 0;
            } else {
              this.charges =
                this.platformFeeData.delivery_charges +
                this.platformFeeData.platform_fee;
            }
            this.discountFunction();
          }

          // if (this.timeSlotDetail.business_type === 1) {
          //   this.isNation = false;
          //   this.isLocal = true;
          // }
          if (this.timeSlotDetail.business_type === 0) {
            this.isNation = true;
            this.isLocal = false;
          }
          console.log(
            "this.timeSlotDetail_delivery_show",
            this.timeSlotDetail_delivery_show
          );
          this.selectOutlet(this.outletIdToSendInCheckout);
        },
        (_error) => {
          console.log("Error: while getting getSlotsListWithAddress()");
        }
      );
  }

  addDayAndTime(day, dayIndex, time, index) {
    console.log("index", index);
    if (time.is_available === false) {
      toastr.error("This slot is not available");
      return;
    }
    $(".clearSlotSelection").removeClass("selectedSlot");
    setTimeout(() => {
      $("#selectedSlot" + index).addClass("selectedSlot");
    }, 100);
    this.dayOfGivenTime = day;
    this.dayIndex = dayIndex;
    console.log("day", this.dayOfGivenTime);
    console.log("this.dayIndex", this.dayIndex);
    this.time = time;
    console.log("day", this.time);
  }

  OvernightFunction(type) {
    if (type === "night") {
      this.breakdownCharges =
        this.timeSlotDetailOrignal.over_night_charges_calculated;
      this.breakdownChargesTotal =
        this.timeSlotDetailOrignal.over_night_charges;
      if (
        this.freeCount === 1 ||
        this.freeCount === 2 ||
        this.freeCount === 3
      ) {
        this.overnight = "Overnight";
      } else {
        this.overnight = "Overnight(Rs. " + this.over_night_charges + ")";
      }
      this.third_party_string = "Overnight";
      this.timeSlotDetail_delivery_charges = this.over_night_charges;
      this.platformFeeData.delivery_charges =
        this.timeSlotDetail_delivery_charges;
      if (this.pickUpCheck == true) {
        this.charges = 0;
      } else {
        this.charges =
          this.platformFeeData.delivery_charges +
          this.platformFeeData.platform_fee;
      }
      this.discountFunction();
      // console.log('Day charges', this.charges);
    }
    if (type === "day") {
      this.breakdownCharges =
        this.timeSlotDetailOrignal.days_charges_calculated;
      this.breakdownChargesTotal = this.timeSlotDetailOrignal.days_charges;
      if (
        this.freeCount === 1 ||
        this.freeCount === 2 ||
        this.freeCount === 3
      ) {
        this.overnight = "3-5 Business Days";
      } else {
        this.overnight = "3-5 Business Days(Rs. " + this.days_charges + ")";
      }
      this.third_party_string = "3-5 Business Days";
      this.timeSlotDetail_delivery_charges = this.days_charges;
      this.platformFeeData.delivery_charges =
        this.timeSlotDetail_delivery_charges;
      if (this.pickUpCheck == true) {
        this.charges = 0;
      } else {
        this.charges =
          this.platformFeeData.delivery_charges +
          this.platformFeeData.platform_fee;
      }
      this.discountFunction();
    }
    this.showBreakdownIcon =
      this.timeSlotDetailOrignal.off_price_subscribed_checked;
  }

  clear_values() {
    this.time = null;
    this.timeSlotDetail_delivery_show = [];
    // this.time.open_time = '';
    // this.time.close_time = '';
    this.dayOfGivenTime = "";
    this.overnight = "";
    this.timeSlotDetail = null;
    this.dayIndex = null;
    this.outletIdToSendInCheckout = null;
    this.third_party_string = "";
  }

  infoPop(obj) {
    this.infoData = obj;
    $("#infoPopOpen").modal("show");
  }

  ngOnInit() {
    // var timer;
    // var contax = this;
    // $('#orderSearchCtrate').keyup(function () {
    //   clearTimeout(timer);
    //   timer = setTimeout(function (event) {
    //     contax.searchProductOnOrder();
    //   }, 1000);
    // });
    this.getDispensaryListing();
    if (window.localStorage.getItem("routetype") == "create") {
      this.filterBusinessId(window.localStorage.getItem("businessId"));
    } else {
      this.filterBusinessId(window.localStorage.getItem("reprocessId"));
    }

    $("#paymentNoCheckCard").css("display", "none");
    $("#paymentNoCheckCash").css("display", "none");
    // this.getBusinessProfile();
    // this.getPlatformFeeFunction();
    // this.get_dispensary_information();
    $("input").on("focus", "input[type=number]", function (_e) {
      $(this).on("mousewheel.disableScroll", function (e) {
        e.preventDefault();
      });
    });
    $("input").on("blur", "input[type=number]", function (_e) {
      $(this).off("mousewheel.disableScroll");
    });
    // $('#discount').keyup(function(e) {
    //   console.log('asasasasasasa');
    //     if ($(this).val() > 100) {
    //        e.preventDefault();
    //     }
    // });
    // this.searchOutletOnOrder();
    // this.inputAddress1();
    // this.inputAddress3();
    $(".header").css("display", "inline-block");
    $(".footer").css("display", "inline-block");
    $(".clearSideSelecteion").css("color", "#3d3d3d");
    $("#order").css("color", "#d77229");
    $(".CustomerSearchBoxHide").css("display", "none");
    $(".editAddressHide").css("display", "none");
    $(function () {
      this.maxYear = new Date().getFullYear();
      this.maxYear = parseInt(this.maxYear) - 21;
      $("#datepicker").datepicker({
        format: "mm/dd/yyyy", // Notice the Extra space at the beginning,
        defaultDate: "-10d",
        endDate: new Date("12/31/" + this.maxYear),
      });
      $("#phone").intlTelInput({
        // autoFormat: true,
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.9/js/utils.jss",
        autoPlaceholder: false,
        preferredCountries: ["GB"],
        preventInvalidNumbers: true,
        // stop the user from typing invalid dial codes
        preventInvalidDialCodes: true,
        formatOnDisplay: true,
        separateDialCode: false,
      });
      var countryCode;
      setTimeout(() => {
        countryCode = $("#phone").intlTelInput(
          "getSelectedCountryData"
        ).dialCode;
        $("#phone").val("+" + countryCode);
      }, 1000);
      $("#phone").change(function () {
        countryCode = $("#phone").intlTelInput(
          "getSelectedCountryData"
        ).dialCode;
        $("#phone").val("+" + countryCode);
      });
    });
  }

  selectGender(val) {
    if (this.gender != val) {
      // this.showGender = true;
    }
    this.gender = val;
  }

  // Recurring Order Feature;
  recurringOrderWeekdays = [
    { day: "M", active: false },
    { day: "T", active: false },
    { day: "W", active: false },
    { day: "T", active: false },
    { day: "F", active: false },
    { day: "S", active: false },
    { day: "S", active: false },
  ];

  recurringOrderMonthly = [
    { day: "1", active: false },
    { day: "2", active: false },
    { day: "3", active: false },
    { day: "4", active: false },
    { day: "5", active: false },
    { day: "6", active: false },
    { day: "7", active: false },
    { day: "8", active: false },
    { day: "9", active: false },
    { day: "10", active: false },
    { day: "11", active: false },
    { day: "12", active: false },
    { day: "13", active: false },
    { day: "14", active: false },
    { day: "15", active: false },
    { day: "16", active: false },
    { day: "17", active: false },
    { day: "18", active: false },
    { day: "19", active: false },
    { day: "20", active: false },
    { day: "21", active: false },
    { day: "22", active: false },
    { day: "23", active: false },
    { day: "24", active: false },
    { day: "25", active: false },
    { day: "26", active: false },
    { day: "27", active: false },
    { day: "28", active: false },
    { day: "29", active: false },
    { day: "30", active: false },
    { day: "31", active: false },
  ];

  weekMap: Map<number, String> = new Map([
    [0, "Monday"],
    [1, "Tuesday"],
    [2, "Wednesday"],
    [3, "Thursday"],
    [4, "Friday"],
    [5, "Saturday"],
    [6, "Sunday"],
  ]);

  // will contain data ready to be sent to API.
  orderRecurrance: {
    status: boolean;
    type: string;
    showFlag: boolean;
  } = {
    status: false,
    type: "Weekly",
    showFlag: false,
  };

  // binded to UI.
  tempOrderRecurrance: {
    status: boolean;
    type: string;
    showFlag: boolean;
  } = {
    status: false,
    type: "Weekly",
    showFlag: false,
  };

  // used to show parsed weekdays in html
  selectedDays: any[] = [];
  // used to send unparsed data to the API
  selectedDaysIds: any[] = [];

  activeWeeklyDay(index, active) {
    this.recurringOrderWeekdays[index].active = active;
  }

  activeMonthlyDay(index, active) {
    this.recurringOrderMonthly[index].active = active;
  }

  resetWeekDays() {
    this.recurringOrderWeekdays.forEach((item: any) => {
      item.active = false;
    });
  }

  resetMonthDays() {
    this.recurringOrderMonthly.forEach((item: any) => {
      item.active = false;
    });
  }

  handleSelectedDays() {
    this.selectedDays = [];
    this.selectedDaysIds = [];

    if (this.tempOrderRecurrance.type === "Weekly") {
      this.recurringOrderWeekdays.forEach((item, i) => {
        if (item.active) {
          // get the day according to index from map to show in html.
          this.selectedDays.push(this.weekMap.get(i));
          this.selectedDaysIds.push(i + 1);
        }
      });
      this.resetMonthDays();
      console.log(this.selectedDays);
    }

    if (this.tempOrderRecurrance.type === "Monthly") {
      this.recurringOrderMonthly.forEach((item, i) => {
        if (item.active) {
          this.selectedDays.push(i + 1);
        }
      });
      // For 'Monthly', dont need to parse dates.
      this.selectedDaysIds = this.selectedDays;
      this.resetWeekDays();
      console.log(this.selectedDays);
    }

    // assign data to [orderRecurrance], that will be send to API.
    this.orderRecurrance.status = this.tempOrderRecurrance.status;
    this.orderRecurrance.type = this.tempOrderRecurrance.type;
    this.orderRecurrance.showFlag = this.tempOrderRecurrance.showFlag;

    if (this.selectedDays.length === 0) {
      toastr.error("Please select atleast one day.");
      return;
    }

    console.log(this.selectedDaysIds);

    this.tempOrderRecurrance.showFlag = false;
  }

  /**
   * cancels any changes made by:
   * applying previously set data to UI variables.
   * reset the days for the type that is not selected.
   * unset radio button to hide view if nothing is selected.
   */
  cancelChanges() {
    this.tempOrderRecurrance.status = this.orderRecurrance.status;
    this.tempOrderRecurrance.type = this.orderRecurrance.type;
    this.tempOrderRecurrance.showFlag = false;
    if (this.tempOrderRecurrance.type === "Monthly") this.resetWeekDays();
    else this.resetMonthDays();
    if (!this.selectedDays.length) this.tempOrderRecurrance.status = undefined;
  }

  /**
   * bring everything back to default.
   */
  resetSubscriptionData() {
    this.tempOrderRecurrance = {
      status: false,
      type: "Weekly",
      showFlag: false,
    };
    this.orderRecurrance = {
      status: false,
      type: "Weekly",
      showFlag: false,
    };
    this.selectedDaysIds = [];
    this.selectedDays = [];
    this.resetMonthDays();
    this.resetWeekDays();
  }

  createOrderFunction() {
    console.log("create order function called");
    this.dispensary_id;
    if (this.productDisplayDataArray.length === 0) {
      toastr.error("Please select a product");
      return;
    }
    if (this.delivery_man_type == 0 || this.delivery_man_type == undefined) {
      toastr.error("Please select a delivery medium");
      console.log("delivery_man_type", this.delivery_man_type);
      return;
    }

    if (this.paymentMethodOptionValue === -1) {
      toastr.error("Please select payment method");
      console.log("customerPrimeryCardNo", this.customerPrimeryCardNo);
      return;
    }

    var errorCount = 0;
    for (var j = 0; j < this.productDisplayDataArray.length; j++) {
      this.productDisplayDataArray[j].error_msg = "";
      if (
        this.productDisplayDataArray[j].quantityTotal === 0 ||
        this.productDisplayDataArray[j].quantityTotal === null ||
        this.productDisplayDataArray[j].quantityTotal === undefined
      ) {
        this.productDisplayDataArray[j].error_msg = "Please add quantity";
        this.btnDisableOrder = false;
        errorCount++;
      }
    }
    if (errorCount > 0) {
      return;
    }
    this.finalProduct = [];
    for (var i = 0; i < this.productDisplayDataArray.length; i++) {
      let modifiers = [];
      if (this.productDisplayDataArray[i].hasModifier === true) {
        for (
          var j = 0;
          j < this.productDisplayDataArray[i].modifiers.length;
          j++
        ) {
          let selectedModifier = {
            title: this.productDisplayDataArray[i].modifiers[j].groupTitle,
            options: {
              title: this.productDisplayDataArray[i].modifiers[j].optionTitle,
              price: this.productDisplayDataArray[i].modifiers[j].optionPrice,
            },
          };
          modifiers.push(selectedModifier);
        }
      }
      let price = -1;
      if (
        this.productDisplayDataArray[i].changeCheck &&
        this.productDisplayDataArray[i].changeCheck == "temporary"
      ) {
        price = parseInt(this.productDisplayDataArray[i].updatedVariantPrice);
      }
      this.finalProduct.push({
        product_id: this.productDisplayDataArray[i].id,
        variant_id: this.productDisplayDataArray[i].variant_id,
        order_detail_id: this.productDisplayDataArray[i].order_detail_id,
        quantity: parseInt(this.productDisplayDataArray[i].quantityTotal),
        addons: this.productDisplayDataArray[i].addons,
        no_options: this.productDisplayDataArray[i].noOption,
        modifiers: modifiers,
        hasModifier: this.productDisplayDataArray[i].hasModifier,
        variant_updated_price: price,
        updated_variant_description:
          this.productDisplayDataArray[i].optionValue,
      });
    }
    errorCount = 0;
    for (var k = 0; k < this.finalProduct.length; k++) {
      if (
        this.finalProduct[k].quantity < 1 ||
        this.finalProduct[k].quantity === null ||
        this.finalProduct[k].quantity === undefined
      ) {
        this.productDisplayDataArray[k].error_msg =
          "Quantity can not be in negative value";
        this.btnDisableOrder = false;
        errorCount++;
      }
    }
    if (errorCount > 0) {
      return;
    }

    if (this.customerDisplayDataArray.length > 0) {
      if (this.customerDisplayDataArray[0].is_default === false) {
        toastr.error("Please select customer delivery address");
        return;
      }
    } else {
      toastr.error("Please select customer");
      return;
    }

    // for (var i = 0; i < this.customerDisplayDataArray.length; i++) {
    console.log("shani 1", this.customerDisplayDataArray);

    var deliveryAddress = {
      area: this.customerDisplayDataArray[0].street,
      street: this.customerDisplayDataArray[0].street,
      city: this.customerDisplayDataArray[0].city,
      state: this.customerDisplayDataArray[0].state,
      zip: this.customerDisplayDataArray[0].zip,
      latitude: this.customerDisplayDataArray[0].latitude,
      house_building_no: this.customerDisplayDataArray[0].house_building_no,
      longitude: this.customerDisplayDataArray[0].longitude,
      country: this.customerDisplayDataArray[0].area,
      apart_no: this.customerDisplayDataArray[0].apart_no,
    };
    // }
    // for (var i = 0; i < this.outletDisplayDataArray.length; i++) {
    console.log(this.outletDisplayDataArray);
    console.log("shani 2", this.outletDisplayDataArray);
    // var outletAddress = {
    //   area: this.outletDisplayDataArray[0].street,
    //   city: this.outletDisplayDataArray[0].city,
    //   state: this.outletDisplayDataArray[0].state,
    //   zip: this.outletDisplayDataArray[0].zip,
    //   country: this.outletDisplayDataArray[0].area,
    //   latitude: this.outletDisplayDataArray[0].latitude,
    //   longitude: this.outletDisplayDataArray[0].longitude,
    // };
    var outletAddress = {
      area: this.outletDisplayDataArray[0].street,
      city: this.outletDisplayDataArray[0].city,
      state: this.outletDisplayDataArray[0].state,
      zip: this.outletDisplayDataArray[0].zip,
      country: this.outletDisplayDataArray[0].area,
      latitude: this.outletDisplayDataArray[0].latitude,
      longitude: this.outletDisplayDataArray[0].longitude,
    };
    this.finalQuantity = this.productDisplayDataArray.length;
    if (this.businessTypeFromSlotRequest === 0) {
      this.time = {};
      if (this.third_party_string === "") {
        toastr.error("Please select your delivery way");
        return;
      }
    }
    if (this.businessTypeFromSlotRequest === 1) {
      if (this.time === undefined || this.time === null) {
        toastr.error("Please select a time slot");
        return;
      }
    }
    if(this.orderType == false ){
       toastr.error("Please select order type")
      return ;
    }

    if (this.time === null) {
      this.time = {};
    }
    this.nao.go(30);
    // this.paymentMethodOptionValue = 0;
    this.btnDisableOrder = true;
    var dayForTime = new Date();
    var currentSystemTime = new Date(dayForTime).toISOString();

    var todayData = this.todayData;
    if (this.todayData === 0) {
      todayData = 7;
    }
    this.tax_charges = this.tax_chargesToDisplay;
    // this.totalPrice += this.tax_chargesToDisplay;
    console.log(this.delivery_man_type);

    var subscriptionData = {};
    if (this.tempOrderRecurrance.status) {
      if (this.selectedDaysIds.length > 0) {
        if (!this.tempOrderRecurrance.showFlag) {
          subscriptionData = {
            type: this.orderRecurrance.type,
            data: this.selectedDaysIds,
          };
        } else {
          toastr.error("Please save your recurring order data");
        }
      } else {
        toastr.error("Please select one or more days");
        return;
      }
    }
    console.log("shani 3");
    if (this.pickUpCheck === true) {
      this.dataService
        .createPickUpOrder(
          window.localStorage.getItem("token"),
          this.finalProduct,
          this.notes,
          this.totalPrice,
          this.finalQuantity,
          this.discount,
          this.tax_charges,
          this.timeSlotDetail_delivery_charges_actual,
          this.customerDisplayDataArray[0].id,
          this.customerDisplayDataArray[0].first_name,
          this.customerDisplayDataArray[0].email,
          this.customerDisplayDataArray[0].phone_number,
          this.outletDisplayDataArray[0].id,
          outletAddress,
          this.subTotal,
          this.delivery_man_type,
          this.paymentMethodOptionValue,
          todayData,
          this.businessTypeFromSlotRequest,
          this.time.open_time,
          this.time.close_time,
          this.dayIndex,
          this.third_party_string,
          currentSystemTime,
          this.dispensary_id,
          this.platform_fee_waive_off
        )
        .subscribe(
          (data) => {
            console.log("outlet data");
            this.nao.go(100);
            this.orderSuccess = data;
            this.orderMessage = this.orderSuccess.message;
            this.orderStatus = this.orderSuccess.status;
            this.orderSuccess = this.orderSuccess.success;
            this.createorderResponseUpdate = data;
            this.createorderResponse = data;
            this.createorderResponse = this.createorderResponse.product;
            this.createorderResponseUpdate =
              this.createorderResponseUpdate.order_update_required;
            console.log(
              "this.createorderResponseUpdate",
              this.createorderResponseUpdate
            );
            if (this.createorderResponseUpdate === true) {
              for (var i = 0; i < this.createorderResponse.length; i++) {
                if (
                  this.createorderResponse[i].variant_id ===
                  this.productDisplayDataArray[i].variant_id
                ) {
                  if (this.createorderResponse[i].out_of_stock === true) {
                    if (this.createorderResponse[i].available_quantity > 0) {
                      this.productDisplayDataArray[i].error_msg =
                        "*available quantity" +
                        " " +
                        this.createorderResponse[i].available_quantity;
                      this.btnDisableOrder = false;
                    } else {
                      this.productDisplayDataArray[i].error_msg =
                        "Out of stock";
                      this.btnDisableOrder = false;
                    }
                    console.log(
                      "updateError",
                      this.productDisplayDataArray[i].error_msg
                    );
                  } else {
                    this.productDisplayDataArray[i].error_msg = "";
                  }
                }
              }
            }
            if (this.orderSuccess === true) {
              toastr.success("Order created successfully");
              this.router.navigate(["order-listing"]);
              this.btnDisableOrder = false;
            } else {
              if (this.orderStatus === 0) {
                this.paymentMethodOptionValue = -1;
                this.getBusinessProfile();
              }
              toastr.error(this.orderMessage);
              this.btnDisableOrder = false;
            }
            this.btnDisableOrder = false;
          },
          (error) => {
            this.nao.go(100);
            console.log("error", error);
          }
        );
    }

    if (this.pickUpCheck == false) {
      this.dataService
        .createOrder(
          window.localStorage.getItem("token"),
          this.finalProduct,
          this.notes,
          this.totalPrice,
          this.finalQuantity,
          this.discount,
          this.tax_charges,
          this.charges,
          this.timeSlotDetail_delivery_charges_actual,
          this.customerDisplayDataArray[0].id,
          this.customerDisplayDataArray[0].first_name,
          this.customerDisplayDataArray[0].email,
          this.customerDisplayDataArray[0].phone_number,
          subscriptionData,
          this.outletDisplayDataArray[0].id,
          outletAddress,
          deliveryAddress,
          this.subTotal,
          this.delivery_man_type,
          this.paymentMethodOptionValue,
          this.logisticsOrder,
          todayData,
          this.businessTypeFromSlotRequest,
          this.time.open_time,
          this.time.close_time,
          this.dayIndex,
          this.third_party_string,
          currentSystemTime,
          this.dispensary_id,
          this.platform_fee_waive_off

        )
        .subscribe(
          (data) => {
            console.log("outlet data");

            this.nao.go(100);
            this.orderSuccess = data;
            this.orderMessage = this.orderSuccess.message;
            this.orderStatus = this.orderSuccess.status;
            this.orderSuccess = this.orderSuccess.success;
            this.createorderResponseUpdate = data;
            this.createorderResponse = data;
            this.createorderResponse = this.createorderResponse.product;
            this.createorderResponseUpdate =
              this.createorderResponseUpdate.order_update_required;
            console.log(
              "this.createorderResponseUpdate",
              this.createorderResponseUpdate
            );
            if (this.createorderResponseUpdate === true) {
              for (var i = 0; i < this.createorderResponse.length; i++) {
                if (
                  this.createorderResponse[i].variant_id ===
                  this.productDisplayDataArray[i].variant_id
                ) {
                  if (this.createorderResponse[i].out_of_stock === true) {
                    if (this.createorderResponse[i].available_quantity > 0) {
                      this.productDisplayDataArray[i].error_msg =
                        "*available quantity" +
                        " " +
                        this.createorderResponse[i].available_quantity;
                      this.btnDisableOrder = false;
                    } else {
                      this.productDisplayDataArray[i].error_msg =
                        "Out of stock";
                      this.btnDisableOrder = false;
                    }
                    console.log(
                      "updateError",
                      this.productDisplayDataArray[i].error_msg
                    );
                  } else {
                    this.productDisplayDataArray[i].error_msg = "";
                  }
                }
              }
            }
            if (this.orderSuccess === true) {
              toastr.success("Order created successfully");
              this.router.navigate(["order-listing"]);
              this.btnDisableOrder = false;
            } else {
              if (this.orderStatus === 0) {
                this.paymentMethodOptionValue = -1;
                this.getBusinessProfile();
              }
              toastr.error(this.orderMessage);
              this.btnDisableOrder = false;
            }
            this.btnDisableOrder = false;
          },
          (error) => {
            this.nao.go(100);
            console.log("error", error);
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/create-order/create-order.component.ts